import axios from "axios";
import URL from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

/**
 * Add JWT token to all request headers
 */
instance.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("token");

    if (typeof token !== "undefined") {
      request.headers.authorization = `Bearer ${token}`;
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// /**
//  * Authenticate user with server using email and password
//  *
//  * @param {*} id
//  * @param {*} password
//  * @returns JWT token that should be used to authenticate future requests
//  */
// export function login(id, password) {
//   return instance
//     .post("/login", { email: id, password: password })
//     .then((response) => {
//       return response.data;
//     });
// }

/**
 * Authenticate user with server using email and password
 *
 * @param {*} id
 * @param {*} password
 * @returns JWT token that should be used to authenticate future requests
 */
export function login(id, password) {
  return instance
    .post("/alpaca/login", { email: id, password: password })
    .then((response) => {
      return response.data;
    });
}

/**
 * Retrieve unique identifier for authenticated user
 *
 * @returns UUID for currently logged in user
 */
export function whoami() {
  return instance.get("/whoAmI").then((response) => {
    return response;
  });
}

/**
 *
 * @param {*} studentid
 * @returns
 */
export function getAssessment(studentid) {
  return instance.get(`/students/${studentid}/assessments`).then((response) => {
    return response.data;
  });
}


/**
 * Get the count of answers for a specific assessment instance
 *
 * @param {string} assessmentInstanceId - The ID of the assessment instance
 * @returns {Promise<{assessmentInstanceId: string, answerCount: number}>} Object containing the assessment instance ID and answer count
 */
export function getAnswerCount(assessmentInstanceId) {
  return instance.get(`/assessment-instances/${assessmentInstanceId}/answers/count`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} studentid
 * @param {*} assessmentid
 * @returns
 */
export function getTask(studentid, assessmentid) {
  return instance
    .get(`/students/${studentid}/assessments/${assessmentid}/tasks`)
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} teacherid
 * @param {*} schoolid
 * @returns
 */

export function getClasses() {
  return instance.get(`classes`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} schoolid
 * @returns
 */

export function getTeachers() {
  return instance.get(`teachers/`).then((response) => {
    console.log(response)
    return response.data;
  });
}

export async function getTeachersBySchoolId(schoolid) {
  try {
    const response = await instance.get(`/schools/${schoolid}/teachers/csd`);
    return response.data;
  } catch (error) {
    console.error('Error fetching teachers for school:', error);
    throw error; // Ensure error is propagated for error handling
  }
}

/**
 * Get teacher by ID
 *
 * @param {string} teacherid - The ID of the teacher to retrieve
 * @returns Promise with teacher data
 */
export function getTeacherById(teacherid) {
  return instance
    .get(`/teachers/${teacherid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getStudentsForClass(classid) {
  return instance.get(`classes/${classid}`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @returns
 */
export function getAssessmentTypes(includeTasks = false) {
  return instance.get(`assessments`, { params: { includeTasks } }).then((response) => {
    return response.data;
  });
}

export function calculateTaskStatsByNcount(calculationScope) {
  return instance
    .post('/statistics/calculateTaskStatsByNcount', calculationScope)
    .then((response) => response.data);
}

export function getAssessmentStatisticsContext(assessmentId, countryId) {
  return instance
    .get(`/statistics/assessment-context/${assessmentId}`, {params: {countryId}})
    .then((response) => response.data);
}

export function updateAssessmentStatistics(calculationScope) {
  return instance
    .post('/statistics/updateAssessmentStatistics', calculationScope)
    .then((response) => response.data);
}

// Additive per-task endpoints for the step-by-step Calculate Standardised
// Scores flow. Sit alongside updateAssessmentStatistics above, not in place
// of it.
export function publishTaskStatistics(payload) {
  return instance
    .post('/statistics/publishTaskStatistics', payload)
    .then((response) => response.data);
}

export function previewNormalizedScoreRecalculation(payload) {
  return instance
    .post('/statistics/previewNormalizedScoreRecalculation', payload)
    .then((response) => response.data);
}

export function runNormalizedScoreRecalculation(payload) {
  return instance
    .post('/statistics/runNormalizedScoreRecalculation', payload)
    .then((response) => response.data);
}

export function assignAssessment(
  selectStudentId,
  selectAssessmentId,
  selectAssessmentName
) {
  // Move console.log statements here
  console.log("selectStudentId: ", selectStudentId);
  console.log("selectAssessmentId: ", selectAssessmentId);
  console.log("selectAssessmentName: ", selectAssessmentName);

  return instance
    .post(`/students/assessments`, {
      students: selectStudentId,
      assessment: {
        id: `${selectAssessmentId}`,
        name: `${selectAssessmentName}`,
      },
      isCustom: false, // Automatically set to true for custom assessments
    })
    .then((response) => {
      console.log("Assignment response: ", response);
      return response.data;
    });
}

/**
 *
 * @param {*} assessmentInstance
 * @returns
 */
export function unassignAssessment(assessmentInstance) {
  // console.log("selectedInstnace: ", assessmentInstance);

  return instance
    .delete(`/assessment-instances/${assessmentInstance.id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Batch unassign multiple assessment instances
 * @param {string[]} assessmentInstanceIds - Array of assessment instance IDs to delete
 * @returns {Promise} - API response
 */
export function unassignAssessmentBatch(assessmentInstanceIds) {
  console.log("Batch deleting assessment instances:", assessmentInstanceIds);

  return instance
    .delete('/assessment-instances/batch', {
      data: { ids: assessmentInstanceIds }
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error in batch unassign:', error);
      throw error;
    });
}


/**
 *
 * @param {*} studentId
 * @param {*} data
 * @returns
 */
export function updateStudent(studentId, data) {
  return instance.patch(`/students/${studentId}`, data).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getClassAssessments(classid) {
  return instance.get(`/classes/${classid}/assessments`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getClassResults(classid) {
  return instance.get(`/classes/${classid}/results`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} assessmentInstanceIDs
 * @returns
 */
export function getResultsByStudent(assessmentInstanceIDs) {
  var params = new URLSearchParams();

  assessmentInstanceIDs.forEach((id) => {
    params.append("assessmentInstanceID", id);
  });

  return instance
    .get("/assessment-instances/results/students", { params: params })
    .then((response) => {
      return response.data;
    });
}

// /**
//  *
//  * @param {*} assessmentInstanceID
//  * @returns
//  */
// export function getResultsByStudent(assessmentInstanceID) {
//   return instance
//     .get("/assessment-instances/results/students", {
//       params: {
//         assessmentInstanceID: `${assessmentInstanceID}`,
//       },
//     })
//     .then((response) => {
//       return response.data;
//     });
// }

/**
 * Fetches all assessment results for a school based on its rollnumber.
 *
 * @param {string} rollnumber - The rollnumber of the school.
 * @returns {Promise} - A promise resolving to the assessment results data.
 */
export function getAllAssessmentInstances(rollnumber) {
  return instance
    .get(`/schools/rollnumber/${rollnumber}/assessment-results`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching assessment results for school:", error);
      throw error;
    });
}

/**
 * Fetch student results using a POST request.
 * @param {Array} assessmentInstanceIDs - An array of assessment instance IDs.
 * @returns Promise resolving to the response data.
 */
export function postResultsByStudent(assessmentInstanceIDs) {
  return instance
    .post("/assessment-instances/results/students", assessmentInstanceIDs)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

/**
 * Fetch student results using a POST request.
 * @param {Array} assessmentInstanceIDs - An array of assessment instance IDs.
 * @returns Promise resolving to the response data.
 */
export function getStudentResults(assessmentInstanceIDs) {
  return instance
    .post("/assessment-instances/results/students", assessmentInstanceIDs)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function getClass(classid) {
  return instance.get(`classes/${classid}`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function editClass(classid, nameOfClass, gradeLevel) {
  return instance
    .patch(`classes/${classid}`, {
      name: `${nameOfClass}`,
      grade_level: `${gradeLevel}`,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function shareClass(classid, teacherid, isSpecialCondition = false) {
  return instance
    .patch(`classes/${classid}/share`, {
      op: "add",
      teacherid: `${teacherid}`,
      isSpecialCondition,
    })
    .then((response) => {
      return response.data;
    });
}
/**
 *
 * @param {*} classid
 * @returns
 */

export function unShareClass(classid, teacherid) {
  return instance
    .patch(`classes/${classid}/share`, {
      op: "remove",
      teacherid: `${teacherid}`,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function addStudents(classid, name) {
  if (name?.length > 0) {
    return instance
      .post(`classes/${classid}/students`, name)
      .then((response) => {
        return response.data;
      });
  } else {
    return null;
  }
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function getStudents(classid) {
  return instance.get(`classes/${classid}`).then((response) => {
    return response.data;
  });
}

export function getCountryGrades(countryid) {
  return instance.get(`/grades/${countryid}`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} name
 * @param {*} grade
 * @param {*} grade1
 * @param {*} grade2
 * @param {*} trialClass
 * @param {*} specialEdClass
 * @returns
 */
export function createClass(
  name,
  grade,
  grade1,
  grade2,
  trialClass,
  specialEdClass, // Should be boolean
  classOwner
) {
  return instance
    .post(`/classes`, {
      name: name,
      grade_level: grade,
      grade_level1: grade1,
      grade_level2: grade2,
      trial_class: trialClass,
      specialed_class: specialEdClass, // Ensure this is a boolean
      classOwnerId: classOwner,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating class:", error.message);
      if (error.response && error.response.data) {
        console.error("Error details:", error.response.data);
      }
      throw error; // Rethrow the error to be handled in the calling code
    });
}


// export function createBulkClasses(classes) {
//   // Validate input
//   if (!Array.isArray(classes) || classes.length === 0) {
//     return Promise.reject(new Error('Classes array cannot be empty'));
//   }

//   // Validate each class has required fields
//   for (let i = 0; i < classes.length; i++) {
//     if (!classes[i].name || typeof classes[i].name !== 'string') {
//       return Promise.reject(new Error(`Class at index ${i} must have a valid name`));
//     }
//   }

//   return instance
//     .post("/classes/bulk", { classes })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       // Enhanced error handling
//       if (error.response) {
//         // Server responded with error status
//         throw new Error(`Server error: ${error.response.status} - ${error.response.data.message || 'Unknown error'}`);
//       } else if (error.request) {
//         // Request was made but no response received
//         throw new Error('Network error: No response from server');
//       } else {
//         // Something else happened
//         throw error;
//       }
//     });
// }

export function createBulkClasses(schoolid, classes) {
  // Validate inputs
  if (!schoolid || typeof schoolid !== 'string') {
    return Promise.reject(new Error('School ID is required'));
  }

  if (!Array.isArray(classes) || classes.length === 0) {
    return Promise.reject(new Error('Classes array cannot be empty'));
  }

  // Validate each class has required fields
  for (let i = 0; i < classes.length; i++) {
    if (!classes[i].name || typeof classes[i].name !== 'string') {
      return Promise.reject(new Error(`Class at index ${i} must have a valid name`));
    }
  }

  return instance
    .post(`/schools/${schoolid}/classes/bulk`, { classes })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Enhanced error handling
      if (error.response) {
        // Server responded with error status
        throw new Error(`Server error: ${error.response.status} - ${error.response.data.message || 'Unknown error'}`);
      } else if (error.request) {
        // Request was made but no response received
        throw new Error('Network error: No response from server');
      } else {
        // Something else happened
        throw error;
      }
    });
}

/**
 * Deletes the specified class
 * Current API implemenation (Sept 2022) does not enforce relational integrity constraints
 * so deleting a class will not delete any students that are associated with the class.
 * However, the link (relationship) between a student and a school will be lost since:
 *
 * School -> Teacher -> Class -> Student -> Assessment
 *
 * @param {*} classid The UUID of the class to delete.
 * @returns true if class deleted successfully (if API responds with a 204 response code)
 */
export function deleteClass(classid) {
  return instance.delete(`/classes/${classid}`).then((response) => {
    let success = false;

    if (response.status === 204) {
      success = true;
    }
    return success;
  });
}

/**
 * Deletes the specified student
 * Current API implemenation (Sept 2022) does not enforce relational integrity constraints
 * so deleting a student will not delete any assessments that are associated with the student.
 * However, the link (relationship) between an assessment and a school/country will be lost since:
 *
 * School -> Teacher -> Class -> Student -> Assessment
 *
/**
 * @param {string} studentid - The UUID of the student to delete.
 * @returns {Promise<boolean>} - true if the student was deleted successfully (if API responds with a 204 response code), false otherwise.
 */
export function deleteStudent(studentId) {
  return instance
    .delete(`/students/${studentId}`)
    .then((response) => {
      console.log(response);
      if (response.status === 204) {
        return true; // Explicitly return true on success
      } else {
        console.error("Unexpected response status:", response.status);
        return false; // Return false if the status is not what is expected
      }
    })
    .catch((error) => {
      // Improved error logging
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error deleting student:", error.message);
        console.error("Status code:", error.response.status);
        console.error("Error data:", error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error(
          "No response received when deleting student:",
          error.request
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error(
          "Error setting up request to delete student:",
          error.message
        );
      }

      return false; // Return false on error
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getQR(classid) {
  return instance.get(`classes/${classid}/qr`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} studentid
 * @returns
 */
export function getIndividualStudentResults(studentid) {
  return instance
    .get(`students/${studentid}/assessments/results`)
    .then((response) => {
      console.log(response.data)
      return response.data;
    });
}

/**
 * Post student answers for a specific task to the server
 *
 * @param {*} studentid
 * @param {*} assessmentid
 * @param {*} taskid
 * @param {*} results
 */
export function saveTaskAnswers(studentid, assessmentid, taskid, results) {
  instance
    .post(
      `/students/${studentid}/assessments/${assessmentid}/tasks/${taskid}/answers`,
      results
    )
    .then((response) => { });
}

/**
 * Post email to request password reset
 *
 * @param {*} email
 *
 */
export function requestPasswordReset(email) {
  return instance.post(`/user/password/request`, { email }).then((response) => {
    return response.data;
  });
}

export function createTeacherSupportRequest(payload) {
  return instance
    .post("/teacher-support-requests", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating teacher support request:", error);
      throw error;
    });
}

export function createClassAccessRequest(schoolId, classId, { targetTeacherId, note } = {}) {
  const body = {};

  if (targetTeacherId) body.targetTeacherId = targetTeacherId;
  if (note) body.note = note;

  return instance
    .post(`/schools/${schoolId}/classes/${classId}/access-requests`, body)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating class access request:", error);
      throw error;
    });
}

export function mergeClasses(schoolid, payload, idempotencyKey) {
  return instance
    .post(`/schools/${schoolid}/classes/merge`, payload, {
      headers: idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    })
    .then((response) => response.data);
}

export function bulkTransitionGradeClasses(payload, idempotencyKey) {
  return instance
    .post(`/schools/transition-grade-bulk`, payload, {
      headers: idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    })
    .then((response) => response.data);
}

export function resolveDuplicateStudentRequest(schoolid, payload) {
  return instance
    .post(`/schools/${schoolid}/students/duplicates/resolve`, payload)
    .then((response) => response.data);
}

export function getStudentDuplicateResults(studentId) {
  return instance
    .get(`/students/${studentId}/duplicate-results`)
    .then((response) => response.data);
}

export function resolveDuplicateResultsRequest(studentId, payload) {
  return instance
    .post(`/students/${studentId}/duplicate-results/resolve`, payload)
    .then((response) => response.data);
}

export function assignScreenerToClass(schoolid, classid, assessmentId) {
  return instance
    .post(`/schools/${schoolid}/classes/${classid}/screeners/assign`, { assessmentId })
    .then((response) => response.data);
}

export function getStudentDeletedAnswers(studentid) {
  return instance
    .get(`/students/${studentid}/deleted-answers`)
    .then((response) => response.data);
}

export function keepNewerDeletedAnswers(studentid, payload) {
  return instance
    .post(`/students/${studentid}/deleted-answers/keep-newer`, payload)
    .then((response) => response.data);
}

export function requestLoginBypassEmail(classid, reason) {
  return instance
    .post(`/classes/${classid}/login-bypass/email`, { reason })
    .then((response) => response.data);
}

export function exportLoginBypass(classid, reason) {
  return instance
    .post(`/classes/${classid}/login-bypass/export`, { reason })
    .then((response) => response.data);
}

export function getLoginBypass(classid, reason) {
  return instance
    .get(`/classes/${classid}/login-bypass`, { params: { reason } })
    .then((response) => response.data);
}

export function getScreeningWindows(schoolid) {
  return instance
    .get(`/schools/${schoolid}/screening-windows`)
    .then((response) => response.data);
}

export function requestResultsVisible(schoolid, payload) {
  return instance
    .post(`/schools/${schoolid}/results-visible/requests`, payload)
    .then((response) => response.data);
}

export function requestPlatformAccess(schoolid, payload) {
  return instance
    .post(`/schools/${schoolid}/platform-access/requests`, payload)
    .then((response) => response.data);
}

export function getAladdinExportReadiness(schoolid, classid, assessmentId) {
  return instance
    .get(`/schools/${schoolid}/classes/${classid}/aladdin-export/readiness`, {
      params: assessmentId ? { assessmentId } : {}
    })
    .then((response) => response.data);
}

export function requestAladdinExportNotify(schoolid, classid, payload) {
  return instance
    .post(`/schools/${schoolid}/classes/${classid}/aladdin-export/notify`, payload)
    .then((response) => response.data);
}

export function requestDataIssue(schoolid, payload) {
  return instance
    .post(`/schools/${schoolid}/data-issues/requests`, payload)
    .then((response) => response.data);
}

export function getTeacherAccountLookup(schoolid) {
  return instance
    .get(`/schools/${schoolid}/teacher-account-lookup`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching teacher account lookup:", error);
      throw error;
    });
}

export function resendTeacherSetupLink(schoolid, pendingteacherid) {
  return instance
    .post(`/schools/${schoolid}/teacher-account-links/setup`, { pendingteacherid })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error resending teacher setup link:", error);
      throw error;
    });
}

export function sendBatchTeacherInvites(schoolid, users) {
  const usersWithDefaults = (Array.isArray(users) ? users : []).map((user) => ({
    ...user,
    roles: user?.roles || "Class teacher",
  }));

  return instance
    .post(`/schools/${schoolid}/teacher-invites/batch`, { users: usersWithDefaults })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error sending batch teacher invites:", error);
      throw error;
    });
}

export function getTeacherGuidanceResources({ query, type, countryId, limit } = {}) {
  const params = {};

  if (query) params.query = query;
  if (type) params.type = type;
  if (countryId) params.countryId = countryId;
  if (limit) params.limit = limit;

  return instance
    .get("/teacher-guidance-resources", { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching teacher guidance resources:", error);
      throw error;
    });
}

export function sendTeacherGuidanceResourceLink(resourceId) {
  return instance
    .post(`/teacher-guidance-resources/${resourceId}/send-link`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error sending teacher guidance resource link:", error);
      throw error;
    });
}

export function requestTeacherWhatsappInvite(payload) {
  return instance
    .post("/teacher-support/whatsapp-invites", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error requesting teacher WhatsApp invite:", error);
      throw error;
    });
}

/**
 * Post new password with token
 * @param {string} password The new password to set.
 * @param {string} token The reset token linked to the user's password reset request.
 */
export function updatePassword(password, token) {
  console.log(password);
  console.log(token);
  return instance
    .post(`/user/password/resetPassword/${token}`, { password })
    .then((response) => {
      console.log("Password update successful:", response.data);
      return { success: true, message: "Password updated successfully." };
    })
    .catch((error) => {
      console.error("Error updating password:", error.response);
      return {
        success: false,
        message: "Failed to update password. Please try again.",
      };
    });
}

/**
 * Fetches all assessment results for a student based on their student ID.
 *
 * @param {string} studentid - The ID of the student.
 * @returns {Promise} - A promise resolving to the assessment results data.
 */
export function getAllStudentResults(studentid) {
  return instance
    .get(`/students/${studentid}/assessments/results`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching assessment results for student:", error);
      throw error;
    });
}

// export function updatePassword(password, token) {
//   return instance.post(`/user/password/resetPassword/${token}`, { password })
//     .then(response => {
//       console.log('Password update successful:', response.data);
//       return { success: true, message: 'Password updated successfully.' };
//     })
//     .catch(error => {
//       console.error('Error updating password:', error.response);
//       if (error.response) {
//         // Handle different cases based on the status code
//         const status = error.response.status;
//         if (status === 404) {
//           return { success: false, message: 'Token not valid or expired.' };
//         } else if (status === 422) {
//           return { success: false, message: 'Validation failed. Check the provided data.' };
//         }
//       }
//       return { success: false, message: 'Failed to update password. Please try again.' };
//     });
// }

/**
 * Update teacher's profile details
 *
 * @param {string} teacherId - The ID of the teacher to update.
 * @param {object} data - The data to update (name, additionalRoles, mobileNumber).
 * @returns The updated teacher data.
 */

export function updateTeacherProfile(schoolId, teacherId, data) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update teacher's profile details including email
 *
 * @param {string} schoolId - The ID of the school the teacher belongs to.
 * @param {string} teacherId - The ID of the teacher to update.
 * @param {object} data - The data to update (name, additionalRoles, mobileNumber, email).
 * @param {string} [data.name] - Teacher's name.
 * @param {string[]} [data.additionalRoles] - Array of additional roles.
 * @param {string} [data.mobileNumber] - Teacher's mobile number.
 * @param {string} [data.email] - Teacher's email address.
 * @returns {Promise} The updated teacher data.
 */
export function updateTeacherProfileWithEmail(schoolId, teacherId, data) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}/profile`, data)
    .then((response) => {
      return response.data;
    });
}


/**
 * Post new user data
 *
 * @param {*} user
 *
 */
export function signupTeacher(user) {
  const { email, password, school } = user;

  // console.log(user)

  return new Promise((resolve, reject) => {
    instance
      .post(`/signup`, {
        email,
        password,
        roles: ["teacher"],
        stakeholderType: "Teacher",
      })
      .then((userData) => {
        login(email, password)
          .then((loginData) => {
            localStorage.setItem("token", loginData.token);
            instance
              .post(`/schools/${school}/teachers`, {
                name: user.name,
                userId: userData.data.id,
                classroomTeacher: true,
                additionalRoles: user.roles,
                mobileNumber: user.mobileNumber,
                language: "en",
              })
              .then((res) => {
                resolve(true);
              })
              .catch((error) => {
                // console.log("Error creating new teacher", error.response);
                reject(false);
              });
          })
          .catch((error) => {
            // console.log("Error logging in new user", error.response);
            reject(false);
          });
      })
      .catch((error) => {
        // console.log("Error creating new user", error.response);
        reject(false);
      });
  });
}

/**
 * Get all schools
 *
 */
export function getSchools() {
  return instance.get("/schools");
}

export function getSchoolsByCountryId(countryid) {
  return instance
    .get(`/schools/by-country/${countryid}`)
    .then((response) => {
      return response.data;
    });
}

export function findSchoolByRollNumber(rollnumber) {
  return instance
    .get(`/schools/rollnumber/${rollnumber}`)
    .then((response) => {
      //  console.log(response.data)
      return response.data;
    });
}

export function findSchoolByEmail(email) {
  return instance
    .get(`/schools/email/${encodeURIComponent(email)}`)
    .then((response) => {
      //  console.log(response.data)
      return response.data;
    });
}

export function findSchoolByIdentifier(identifier) {
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);

  if (isEmail) {
    return findSchoolByEmail(identifier);
  } else {
    return findSchoolByRollNumber(identifier);
  }
}

/**
 * Get all schools
 *
 */
export function getIndividualSchool(schoolid) {
  return instance.get(`/schools/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Get all rolescd
 *
 */
export function getRoles() {
  return instance.get("/roles");
}

export function getPendingTeacher(pendingteacherid) {
  return instance
    .get(`/pending-teachers/${pendingteacherid}`)
    .then((response) => {
      //  console.log(response.data)
      return response.data;
    });
}

export function deletePendingTeacher(pendingteacherid) {
  return instance
    .delete(`/pending-teachers/${pendingteacherid}`)
    .then((response) => {
      // console.log(response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error deleting pending teacher:", error);
      throw error;
    });
}


/**
 *
 * @param {*} schoolid
 * @returns
 */
export function getPendingTeacherBySchoolId(schoolid) {
  return instance
    .get(`/pending-teachers/school/${schoolid}`)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        console.warn(`No pending teachers found for school ID: ${schoolid}`);
        // Optionally return an empty array or some other default response
        return [];
      } else {
        console.error("Error fetching pending teachers:", error);
        // Rethrow the error if it's something other than 404
        throw error;
      }
    });
}


export function addAdditionalColleagues(
  schoolId,
  rollnumber,
  colleagues,
  teacherName,
  countryId
) {
  console.log(schoolId);
  console.log(rollnumber);
  console.log(colleagues);
  console.log(teacherName);
  console.log(countryId);

  if (!colleagues || colleagues.length === 0) {
    console.warn("No colleagues provided to add.");
    return Promise.reject("No colleagues provided to add.");
  }

  // Include sharedClassId if provided, otherwise omit it
  const users = colleagues.map(
    ({ firstName, lastName, email, roles, sharedClassId }) => {
      const user = {
        firstName,
        lastName,
        email,
        rollnumber,
        roles: roles || "Teacher",
      };

      // Only include sharedClassId if it's provided and not null/undefined
      if (sharedClassId) {
        user.sharedClassId = sharedClassId;
      }

      return user;
    }
  );

  const payload = {
    users,
    schoolId,
    teacherName,
    countryId
  };

  console.log("PAYLOAD:", payload);

  return instance
    .post("/pending-teachers", payload)
    .then((response) => {
      console.log(response);
      return response.data || true; // Handle 204 responses
    })
    .catch((error) => {
      console.error("Error adding additional colleagues:", error);
      throw error;
    });
}

/**
 * Check if the colleague already exists in the pending teachers' table.
 *
 * @param {string} email - The email of the colleague to check.
 * @returns {Promise<boolean>} - True if the colleague exists, false otherwise.
 */
export function checkColleagueExists(email) {
  return instance
    .get("/pending-teachers/check", { params: { email } })
    .then((response) => response.data.exists)
    .catch((error) => {
      console.error("Error checking if colleague exists:", error);
      throw error;
    });
}

/**
 * Function to submit multiple referrals.
 * @param {string} referrerId - The ID of the teacher making the referrals.
 * @param {Array} referrals - Array of objects, each containing the email (and possibly name) of the referred teacher.
 * @returns {Promise} A promise that resolves to the response of the API call.
 */
export function submitMultipleReferrals(teacherId, referrals, teacherADetails) {
  if (!referrals || referrals.length === 0) {
    console.warn("No referrals provided.");
    return Promise.reject("No referrals provided.");
  }

  const referralEntries = referrals.map(({ email, firstName, lastName }) => ({
    teacherId,
    referredEmail: email,
    firstName,
    lastName,
    referralCode: "DefaultCode",
    status: "Pending",
    inPendingTeacherTable: false,
    uniqueUrlSent: false,
    createDate: new Date().toISOString(),
    // Including TeacherA's details
    referrerName: teacherADetails.fullName,
    referrerEmail: teacherADetails.email,
  }));

  console.log(referralEntries);

  return instance
    .post("/referrals/batch", referralEntries)
    .then((response) => {
      console.log("Submission successful", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error submitting multiple referrals:", error);
      throw error;
    });
}

/**
 * Fetch report options based on the type of report.
 * @param {boolean} isSenco - If true, fetch options for SENCO, false for JISI.
 * @returns {Promise}
 */
export function getReportOptions(isSenco) {
  const reportTypeParam = isSenco ? "sencoreport=true" : "jisireport=true";
  return instance
    .get(`/report-options?${reportTypeParam}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching report options:", error);
      throw error;
    });
}

/**
 * Upserts JISI report based on the provided data.
 * @param {Object} reportData - The JSON data for the JISI report.
 * @returns {Promise}
 */
export function upsertJiSiReport(reportData) {
  return instance
    .post("/ji-si-reports/upsert", reportData)
    .then((response) => {
      console.log("Upsert JISI Report Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error upserting JISI Report:", error);
      throw error;
    });
}

/**
 * Fetches a JiSiReport based on student ID.
 * @param {string} studentId - The ID of the student to fetch the report for.
 * @returns {Promise}
 */
export function getJiSiReportByStudentId(studentId) {
  return instance
    .get(`/ji-si-reports/by-student/${studentId}`)
    .then((response) => {
      // console.log("Fetched JiSi Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching JiSi Report by student ID:", error);
      throw error;
    });
}

/**
 * Fetches a JiSiReport based on class ID.
 * @param {string} classId - The ID of the class to fetch the report for.
 * @returns {Promise}
 */
export function getJiSiReportByClassId(classId) {
  return instance
    .get(`/ji-si-reports/by-class/${classId}`)
    .then((response) => {
      // Logging can be uncommented for debugging purposes or removed after testing
      // console.log("Fetched JiSi Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching JiSi Report by class ID:", error);
      // Propagating error up to the caller allows for more flexible error handling
      throw error;
    });
}

/**
 * Upserts SENCO report based on the provided data.
 * @param {Object} reportData - The JSON data for the SENCO report.
 * @returns {Promise}
 */
export function upsertSencoReport(reportData) {
  return instance
    .post("/senco-reports/upsert", reportData)
    .then((response) => {
      console.log("Upsert SENCO Report Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error upserting SENCO Report:", error);
      throw error;
    });
}

/**
 * Fetches a SencoReport based on student ID.
 * @param {string} studentId - The ID of the student to fetch the report for.
 * @returns {Promise}
 */
export function getSencoReportByStudentId(studentId) {
  return instance
    .get(`/senco-reports/by-student/${studentId}`)
    .then((response) => {
      console.log("Fetched SENCO Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching SENCO Report by student ID:", error);
      throw error;
    });
}

/**
 * Fetches a SencoReport based on class ID.
 * @param {string} classId - The ID of the class to fetch the report for.
 * @returns {Promise}
 */
export function getSencoReportByClassId(classId) {
  return instance
    .get(`/senco-reports/by-class/${classId}`)
    .then((response) => {
      // Logging can be uncommented for debugging purposes or removed after testing
      // console.log("Fetched Senco Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching Senco Report by class ID:", error);
      // Propagating error up to the caller allows for more flexible error handling
      throw error;
    });
}

/**
 * Resend an invitation to a teacher using a POST request.
 * @param {string} teacherId - The ID of the teacher to whom the invite should be resent.
 * @returns {Promise} - A promise resolving to the response data.
 */
export function resendTeacherInvite(teacherId) {
  return instance
    .post(`/pending-teachers/remind/${teacherId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error resending invite:", error);
      throw error;
    });
}

/**
 * Add Alpaca Lead role to a teacher
 */
export function addAlpacaLeadRole(schoolId, teacherId) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}/add-alpaca-lead`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error adding Alpaca Lead role:", error);
      throw error;
    });
}

/**
 * Remove Alpaca Lead role from a teacher
 */
export function removeAlpacaLeadRole(schoolId, teacherId) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}/remove-alpaca-lead`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error removing Alpaca Lead role:", error);
      throw error;
    });
}

/**
 * Search users by email (partial, case-insensitive match)
 */
export function searchUsersByEmail(email) {
  return instance
    .get("/users/search", { params: { email } })
    .then((response) => response.data);
}

/**
 * List all users currently holding the alpaca-staff role
 */
export function getAlpacaStaffList() {
  return instance.get("/users/alpaca-staff").then((response) => response.data);
}

/**
 * Audit trail of alpaca-staff grants/revocations
 */
export function getAlpacaStaffHistory() {
  return instance
    .get("/users/alpaca-staff/history")
    .then((response) => response.data);
}

/**
 * Grant alpaca-staff privileges to a user
 */
export function grantAlpacaStaff(userId) {
  return instance
    .patch(`/users/${userId}/grant-alpaca-staff`)
    .then((response) => response.data);
}

/**
 * Revoke alpaca-staff privileges from a user
 */
export function revokeAlpacaStaff(userId) {
  return instance
    .patch(`/users/${userId}/revoke-alpaca-staff`)
    .then((response) => response.data);
}

/**
 * Function to update the class ID of a student
 * @param {string} studentId - The ID of the student to update
 * @param {string} newClassId - The new class ID to assign to the student
 * @returns {Promise} - A promise resolving to the response data
 */
export function updateStudentClassId(studentId, newClassId) {
  return instance.patch(`/students/${studentId}/class-id`, {
    classId: newClassId,
  });
}

/**
 * Bulk update class ID for multiple students
 *
 * @param {Object} params - Parameters object
 * @param {string[]} params.studentIds - Array of student IDs to update
 * @param {string} params.classId - New class ID to assign to all students
 * @returns {Promise<{updated: string[], notFound: string[], totalRequested: number, totalUpdated: number}>} Update results
 */
export function bulkUpdateStudentClassId({ studentIds, classId }) {
  console.log("Bulk updating class ID for students:", studentIds, "to class ID:", classId);
  return instance.patch("/students/bulk/class-id", {
    studentIds: studentIds,
    classId: classId
  }).then((response) => {
    return response.data;
  });
}

/**
 * Fetches AnswerDeletionReason options.
 * @returns {Promise}
 */
export function getAnswerDeletionReasonOptions() {
  return instance
    .get("answer-deletion-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching AnswerDeletionReason options:", error);
      throw error;
    });
}

/**
 * Fetches ChangeClassReason options.
 * @returns {Promise}
 */
export function getChangeClassReasonOptions() {
  return instance
    .get("/change-class-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching ChangeClassReason options:", error);
      throw error;
    });
}

/**
 * Fetches Change Alpaca Lead options.
 * @returns {Promise}
 */
export function getAlpacaLeadChangeReasonOptions() {
  return instance
    .get("/alpaca-lead-change-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching AlpacaLeadChange options:", error);
      throw error;
    });
}
/**
 * Deletes the specified student
 * Current API implemenation (Sept 2022) does not enforce relational integrity constraints
 * so deleting a student will not delete any assessments that are associated with the student.
 * However, the link (relationship) between an assessment and a school/country will be lost since:
 *
 * School -> Teacher -> Class -> Student -> Assessment
 *
/**
 * @param {string} answerId - The UUID of the answer to delete.
 * @returns {Promise<boolean>} - true if the answer was deleted successfully (if API responds with a 204 response code), false otherwise.
 */
export function deleteAnswer(answerId) {
  return instance
    .delete(`/answers/${answerId}`)
    .then((response) => {
      console.log(response);
      if (response.status === 204) {
        return true; // Explicitly return true on success
      } else {
        console.error("Unexpected response status:", response.status);
        return false; // Return false if the status is not what is expected
      }
    })
    .catch((error) => {
      // Improved error logging
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error deleting student:", error.message);
        console.error("Status code:", error.response.status);
        console.error("Error data:", error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error(
          "No response received when deleting answer:",
          error.request
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error(
          "Error setting up request to delete answer:",
          error.message
        );
      }

      return false; // Return false on error
    });
}

export function deleteAnswers(deletionData) {
  return instance
    .delete("/answers", {
      data: {
        answerIds: deletionData.answerIds,
        teacherId: deletionData.teacherId,
        deletionReasonId: deletionData.deletionReasonId,
        deletionReason: deletionData.deletionReason
      }
    })
    .then((response) => {
      console.log(response);
      if (response.status === 204) {
        return true;
      } else {
        console.error("Unexpected response status:", response.status);
        return false;
      }
    })
    .catch((error) => {
      if (error.response) {
        console.error("Error deleting answers:", error.message);
        console.error("Status code:", error.response.status);
        console.error("Error data:", error.response.data);
      } else if (error.request) {
        console.error("No response received when deleting answers:", error.request);
      } else {
        console.error("Error setting up request to delete answers:", error.message);
      }
      return false;
    });
}

// /**
//  * Updates the answer deletion reason table.
//  * @param {string} answerId - The UUID of the answer.
//  * @param {string} reasonId - The ID of the deletion reason.
//  * @param {string} deletionReason - The textual reason for deletion.
//  * @returns {Promise<boolean>} - true if the deletion reason was updated successfully, false otherwise.
//  */
// export function updateAnswerDeletionReason(answerId, reasonId, deletionReason, teacherId) {
//   return instance
//     .post(`/answer-deletion-reasons`, {
//       answerid: answerId,
//       answerdeletionreasonsid: reasonId,
//       deletionreason: deletionReason,
//       teacherid: teacherId,

//     })
//     .then((response) => {
//       console.log(response);
//       return response.status === 200;
//     })
//     .catch((error) => {
//       console.error("Error updating answer deletion reason:", error);
//       return false;
//     });
// }

/**
 * Creates an AnswerDeleted record based on the provided data.
 * @param {Object} answerDeletedData - The JSON data for the AnswerDeleted record.
 * @returns {Promise}
 */
export function updateAnswerDeletionReason(answerDeletedData) {
  return instance
    .post("/answers-deleted", answerDeletedData)
    .then((response) => {
      console.log("Answer Deleted Record Creation Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Answer Deleted Record:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error request data:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
      }
      throw error;
    });
}

/**
 * Creates an AnswerDeleted record based on the provided data.
 * @param {Object} classChangedData - The JSON data for the AnswerDeleted record.
 * @returns {Promise}
 */
export function updateClassChangeReason(classChangedData) {
  return instance
    .post("/class-change-histories", classChangedData)
    .then((response) => {
      console.log("Class Changed Record Creation Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Class Changed Record:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error request data:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
      }
      throw error;
    });
}

/**
 * Creates an AnswerDeleted record based on the provided data.
 * @param {Object} alpacaLeadChangeData - The JSON data for the AnswerDeleted record.
 * @returns {Promise}
 */
export function updateAlpacaLeadChangeReason(alpacaLeadChangeData) {
  return instance
    .post("/alpaca-lead-histories", alpacaLeadChangeData)
    .then((response) => {
      console.log(
        "Alpaca Lead Changed Record Creation Success:",
        response.data
      );
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Alpaca Lead Changed Record:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error request data:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
      }
      throw error;
    });
}

/**
 * Creates a SpecialEdStudent based on the provided data.
 * @param {Object} studentData - The JSON data for the SpecialEdStudent.
 * @returns {Promise}
 */
export function createSpecialEdStudent(studentData) {
  return instance
    .post("/special-ed-students", studentData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating SpecialEdStudent:", error);
      throw error;
    });
}

/**
 *
 * @param {*} schoolid
 * @returns
 */
export function getAllowedProperties(schoolid) {
  return instance.get(`/schools/${schoolid}/config`).then((response) => {
    return response.data;
  });
}

/**
 * Fetches all ClassOwnerChangeReason entries.
 *
 * @returns {Promise<Array>} - A promise that resolves to an array of ClassOwnerChangeReason data.
 */
export function getClassOwnerChangeReasons() {
  return instance
    .get("/class-owner-change-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching ClassOwnerChangeReasons:", error);
      throw error;
    });
}

/**
 * Updates the classOwnerId of a class by ID.
 *
 * @param {string} classId - The ID of the class to update.
 * @param {string} classOwnerId - The new classOwnerId value.
 * @returns {Promise<object>} - A promise that resolves to the updated class data.
 */
export function updateClassOwnerId(classId, classOwnerId) {
  // Prepare the data object to send in the request body
  const data = {
    classOwnerId: classOwnerId,
  };

  return instance
    .patch(`/classes/${classId}`, data)
    .then((response) => {
      // Return the updated class data from the response
      return response.data;
    })
    .catch((error) => {
      // Handle errors if the request fails
      console.error("Error updating classOwnerId:", error);
      throw error; // Re-throw the error to be handled by the caller
    });
}

/**
 * Creates a new ClassOwnershipHistory entry.
 *
 * @param {Object} classOwnershipHistoryData - The data for the new ClassOwnershipHistory entry.
 * @param {string} classOwnershipHistoryData.teacherId - The ID of the teacher associated with the ownership change.
 * @param {string} classOwnershipHistoryData.oldClassOwner - The ID of the previous class owner.
 * @param {string} classOwnershipHistoryData.newClassOwner - The ID of the new class owner.
 * @param {string} classOwnershipHistoryData.reasonForChangeId - The ID of the reason for the ownership change.
 * @param {string} [classOwnershipHistoryData.classownerchangereason] - A string describing the reason for the change.
 * @param {Date} [classOwnershipHistoryData.dateChanged] - The date of the ownership change. Defaults to the current date.
 * @returns {Promise<Object>} - A promise that resolves to the newly created ClassOwnershipHistory data.
 */
export function createClassOwnershipHistory(classOwnershipHistoryData) {
  return instance
    .post("/class-ownership-histories", classOwnershipHistoryData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating ClassOwnershipHistory:", error);
      throw error;
    });
}

/**
 * Updates the grade levels of a class.
 *
 * This function sets `grade_level1` to `false` and `grade_level2` to `true` for the specified class.
 *
 * @param {string} classId - The ID of the class to update.
 * @returns {Promise<void>} - A promise that resolves when the update is complete.
 */
export function updateGradeLevels(classId) {
  return axios
    .patch(`/classes/${classId}/update-grade-levels`)
    .then((response) => {
      console.log("Grade levels updated successfully");
    })
    .catch((error) => {
      console.error("Error updating grade levels:", error);
      throw error;
    });
}

/**
 * Creates a LastLogin based on the provided data.
 * @param {Object} studentData - The JSON data for the LastLogin.
 * @returns {Promise}
 */
export function postLastLogin(teacherid) {
  return instance
    .post("/lastloggedin", { teacherid })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Logging Last Login:", error);
      throw error;
    });
}

/**
 * Fetches the most recent LastLogin entry for the given teacherid.
 * @param {string} teacherid - The teacher's ID.
 * @returns {Promise}
 */
export function getLastLogin(teacherid) {
  return instance
    .get(`/lastloggedin/${teacherid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching last login:", error);
      throw error;
    });
}

export function getAllStudentsResultsPerAssessment(
  studentIds,
  assessmentInstanceIds
) {
  // Log the data being passed to the function
  console.log("Preparing to send request with the following data:");
  console.log("Student IDs:", studentIds);
  console.log("Assessment Instance IDs:", assessmentInstanceIds);

  return instance
    .post("/students/assessments/results", {
      studentIds: studentIds,
      assessmentInstanceIds: assessmentInstanceIds,
    })
    .then((response) => {
      // Log the response data
      console.log("Received response:", response.data);
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

export async function getClassesBySchoolId(schoolid) {
  try {
    const response = await instance.get(`/schools/${schoolid}/classes/csd`);
    return response.data;
  } catch (error) {
    console.error('Error fetching classes for school:', error);
    throw error;
  }
}

// export async function getStudentsByClassId(classid) {
//   try {
//     const response = await instance.get(`/classes/${classid}/students/csd`);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching students for class:', error);
//     throw error;
//   }
// }

export async function getStudentsByClassId(schoolid, classid) {
  try {
    console.log('🔵 [getStudentsByClassId] Fetching students...');
    console.log('🔵 [getStudentsByClassId] School ID:', schoolid);
    console.log('🔵 [getStudentsByClassId] Class ID:', classid);

    const response = await instance.get(`/schools/${schoolid}/classes/${classid}/students/csd`);

    console.log('✅ [getStudentsByClassId] Success!');
    console.log('✅ [getStudentsByClassId] Students count:', response.data.length);

    return response.data;
  } catch (error) {
    console.error('❌ [getStudentsByClassId] Error occurred');
    console.error('❌ [getStudentsByClassId] Error message:', error.message);
    console.error('❌ [getStudentsByClassId] Error status:', error.response?.status);
    console.error('❌ [getStudentsByClassId] Error data:', error.response?.data);
    throw error;
  }
}

export function searchSchoolStudents(schoolid, query, limit = 25) {
  return instance
    .get(`/schools/${schoolid}/students/search/csd`, {
      params: {
        query,
        limit,
      },
    })
    .then((response) => response.data);
}

export function searchTeacherStudents(query, limit = 25) {
  return instance
    .get("/teachers/me/students/search/csd", {
      params: {
        query,
        limit,
      },
    })
    .then((response) => response.data);
}

// export async function getAssessmentsByStudentId(studentid) {
//   try {
//     const response = await instance.get(`/students/${studentid}/assessments/csd`);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching assessments for student:', error);
//     throw error;
//   }
// }

export async function getAssessmentsByStudentId(schoolid, studentid) {
  try {
    console.log('🔵 [getAssessmentsByStudentId] Fetching assessments...');
    console.log('🔵 [getAssessmentsByStudentId] School ID:', schoolid);
    console.log('🔵 [getAssessmentsByStudentId] Student ID:', studentid);

    const response = await instance.get(`/schools/${schoolid}/students/${studentid}/assessments/csd`);

    console.log('✅ [getAssessmentsByStudentId] Success!');
    console.log('✅ [getAssessmentsByStudentId] Assessments count:', response.data.length);

    return response.data;
  } catch (error) {
    console.error('❌ [getAssessmentsByStudentId] Error occurred');
    console.error('❌ [getAssessmentsByStudentId] Error message:', error.message);
    console.error('❌ [getAssessmentsByStudentId] Error status:', error.response?.status);
    console.error('❌ [getAssessmentsByStudentId] Error data:', error.response?.data);
    throw error;
  }
}

// export async function swapAssessmentStudents(firstAssessmentInstanceId, secondAssessmentInstanceId) {
//   try {
//     await instance.patch('/assessments/swap/csd', {
//       firstAssessmentInstanceId,
//       secondAssessmentInstanceId,
//     });
//   } catch (error) {
//     console.error('Error swapping students in assessment instances:', error);
//     throw error;
//   }
// }

// export async function transferAssessmentToStudent(assessmentInstanceId, targetStudentId) {
//   try {
//     await instance.patch('/assessments/transfer/direct', {
//       assessmentInstanceId,
//       targetStudentId,
//     });
//   } catch (error) {
//     console.error('Error transferring assessment to student:', error);
//     throw error;
//   }
// }

export async function swapAssessmentStudents(schoolid, firstAssessmentInstanceId, secondAssessmentInstanceId) {
  try {
    console.log('🔵 [swapAssessmentStudents] Starting assessment swap...');
    console.log('🔵 [swapAssessmentStudents] School ID:', schoolid);
    console.log('🔵 [swapAssessmentStudents] First Assessment ID:', firstAssessmentInstanceId);
    console.log('🔵 [swapAssessmentStudents] Second Assessment ID:', secondAssessmentInstanceId);

    const response = await instance.patch(`/schools/${schoolid}/assessments/swap/csd`, {
      firstAssessmentInstanceId,
      secondAssessmentInstanceId,
    });

    console.log('✅ [swapAssessmentStudents] Success!');
    console.log('✅ [swapAssessmentStudents] Status:', response.status);

    return response;
  } catch (error) {
    console.error('❌ [swapAssessmentStudents] Error occurred');
    console.error('❌ [swapAssessmentStudents] Error message:', error.message);
    console.error('❌ [swapAssessmentStudents] Error status:', error.response?.status);
    console.error('❌ [swapAssessmentStudents] Error data:', error.response?.data);
    throw error;
  }
}

export async function transferAssessmentToStudent(schoolid, assessmentInstanceId, targetStudentId) {
  try {
    console.log('🔵 [transferAssessmentToStudent] Starting assessment transfer...');
    console.log('🔵 [transferAssessmentToStudent] School ID:', schoolid);
    console.log('🔵 [transferAssessmentToStudent] Assessment Instance ID:', assessmentInstanceId);
    console.log('🔵 [transferAssessmentToStudent] Target Student ID:', targetStudentId);

    const response = await instance.post(`/schools/${schoolid}/assessments/transfer/teacher`, {
      assessmentInstanceId,
      targetStudentId,
    });

    console.log('✅ [transferAssessmentToStudent] Success!');
    console.log('✅ [transferAssessmentToStudent] Status:', response.status);

    return response.data;
  } catch (error) {
    console.error('❌ [transferAssessmentToStudent] Error occurred');
    console.error('❌ [transferAssessmentToStudent] Error message:', error.message);
    console.error('❌ [transferAssessmentToStudent] Error status:', error.response?.status);
    console.error('❌ [transferAssessmentToStudent] Error data:', error.response?.data);
    throw error;
  }
}

// export async function softDeleteClass(data) {
//   try {
//     await instance.delete(`/classes/${data.classid}/csd`, {
//       data: {
//         deletionReason: data.deletionReason,
//         teacherId: data.teacherId
//       }
//     });
//   } catch (error) {
//     console.error('Error deleting class:', error);
//     throw error;
//   }
// }

export async function softDeleteClass(schoolid, data) {
  try {
    console.log('🔵 [softDeleteClass] Starting soft delete...');
    console.log('🔵 [softDeleteClass] School ID:', schoolid);
    console.log('🔵 [softDeleteClass] Class ID:', data.classid);
    console.log('🔵 [softDeleteClass] Payload:', {
      deletionReason: data.deletionReason,
      teacherId: data.teacherId
    });

    const response = await instance.delete(`/schools/${schoolid}/classes/${data.classid}/csd`, {
      data: {
        deletionReason: data.deletionReason,
        teacherId: data.teacherId
      }
    });

    console.log('✅ [softDeleteClass] Success!');
    console.log('✅ [softDeleteClass] Status:', response.status);

    return response;
  } catch (error) {
    console.error('❌ [softDeleteClass] Error occurred');
    console.error('❌ [softDeleteClass] Error message:', error.message);
    console.error('❌ [softDeleteClass] Error status:', error.response?.status);
    console.error('❌ [softDeleteClass] Error data:', error.response?.data);
    throw error;
  }
}

export async function batchDeleteStudents(data) {
  try {
    const response = await instance.delete('/students/batch', {
      data: {
        studentIds: data.studentIds,
        deletionReason: data.deletionReason,
        deletedByTeacherId: data.deletedByTeacherId,
        deletedByTeacherName: data.deletedByTeacherName
      }
    });
    return response.data; // Returns the detailed response with counts and errors
  } catch (error) {
    console.error('Error batch deleting students:', error);
    throw error;
  }
}


// export async function deleteTeacherArchived(data) {
//   try {
//     await instance.delete(`/teachers/${data.teacherid}`, {
//       data: {
//         deletionReason: data.deletionReason,
//         deletedByTeacherId: data.deletedByTeacherId,
//         deletedByTeacherName: data.deletedByTeacherName
//       }
//     });
//   } catch (error) {
//     console.error('Error deleting teacher:', error);
//     throw error;
//   }
// }

// export async function deleteTeacherArchived(data) {
//   try {
//     console.log('🔵 [deleteTeacherArchived] Starting archive delete...');
//     console.log('🔵 [deleteTeacherArchived] Teacher ID:', data.teacherid);
//     console.log('🔵 [deleteTeacherArchived] Payload:', {
//       deletionReason: data.deletionReason,
//       deletedByTeacherId: data.deletedByTeacherId,
//       deletedByTeacherName: data.deletedByTeacherName
//     });

//     console.log('🔵 [deleteTeacherArchived] Making request to:', `/teachers/${data.teacherid}`);
//     console.log('🔵 [deleteTeacherArchived] Request config:', {
//       method: 'DELETE',
//       url: `/teachers/${data.teacherid}`,
//       data: {
//         deletionReason: data.deletionReason,
//         deletedByTeacherId: data.deletedByTeacherId,
//         deletedByTeacherName: data.deletedByTeacherName
//       }
//     });

//     const response = await instance.delete(`/teachers/${data.teacherid}`, {
//       data: {
//         deletionReason: data.deletionReason,
//         deletedByTeacherId: data.deletedByTeacherId,
//         deletedByTeacherName: data.deletedByTeacherName
//       }
//     });

//     console.log('✅ [deleteTeacherArchived] Success!');
//     console.log('✅ [deleteTeacherArchived] Status:', response.status);
//     console.log('✅ [deleteTeacherArchived] Response:', response);

//     return response;
//   } catch (error) {
//     console.error('❌ [deleteTeacherArchived] Error occurred');
//     console.error('❌ [deleteTeacherArchived] Error message:', error.message);
//     console.error('❌ [deleteTeacherArchived] Error status:', error.response?.status);
//     console.error('❌ [deleteTeacherArchived] Error data:', error.response?.data);
//     console.error('❌ [deleteTeacherArchived] Error headers:', error.response?.headers);
//     console.error('❌ [deleteTeacherArchived] Error config:', error.config);
//     console.error('❌ [deleteTeacherArchived] Full error:', error);
//     throw error;
//   }
// }


// Updated teacher deletion functions with schoolid parameter

export async function softDeleteTeacher(schoolid, teacherid) {
  try {
    console.log('🔵 [softDeleteTeacher] Starting soft delete...');
    console.log('🔵 [softDeleteTeacher] School ID:', schoolid);
    console.log('🔵 [softDeleteTeacher] Teacher ID:', teacherid);

    const response = await instance.delete(`/schools/${schoolid}/teachers/${teacherid}/csd`);

    console.log('✅ [softDeleteTeacher] Success!');
    console.log('✅ [softDeleteTeacher] Status:', response.status);
    console.log('✅ [softDeleteTeacher] Response:', response);

    return response;
  } catch (error) {
    console.error('❌ [softDeleteTeacher] Error occurred');
    console.error('❌ [softDeleteTeacher] Error message:', error.message);
    console.error('❌ [softDeleteTeacher] Error status:', error.response?.status);
    console.error('❌ [softDeleteTeacher] Error data:', error.response?.data);
    console.error('❌ [softDeleteTeacher] Error headers:', error.response?.headers);
    console.error('❌ [softDeleteTeacher] Full error:', error);
    throw error;
  }
}

export async function deleteTeacherArchived(schoolid, data) {
  try {
    console.log('🔵 [deleteTeacherArchived] Starting archive delete...');
    console.log('🔵 [deleteTeacherArchived] School ID:', schoolid);
    console.log('🔵 [deleteTeacherArchived] Teacher ID:', data.teacherid);
    console.log('🔵 [deleteTeacherArchived] Payload:', {
      deletionReason: data.deletionReason,
      deletedByTeacherId: data.deletedByTeacherId,
      deletedByTeacherName: data.deletedByTeacherName
    });

    console.log('🔵 [deleteTeacherArchived] Making request to:', `/schools/${schoolid}/teachers/${data.teacherid}`);
    console.log('🔵 [deleteTeacherArchived] Request config:', {
      method: 'DELETE',
      url: `/schools/${schoolid}/teachers/${data.teacherid}`,
      data: {
        deletionReason: data.deletionReason,
        deletedByTeacherId: data.deletedByTeacherId,
        deletedByTeacherName: data.deletedByTeacherName
      }
    });

    const response = await instance.delete(`/schools/${schoolid}/teachers/${data.teacherid}`, {
      data: {
        deletionReason: data.deletionReason,
        deletedByTeacherId: data.deletedByTeacherId,
        deletedByTeacherName: data.deletedByTeacherName
      }
    });

    console.log('✅ [deleteTeacherArchived] Success!');
    console.log('✅ [deleteTeacherArchived] Status:', response.status);
    console.log('✅ [deleteTeacherArchived] Response:', response);

    return response;
  } catch (error) {
    console.error('❌ [deleteTeacherArchived] Error occurred');
    console.error('❌ [deleteTeacherArchived] Error message:', error.message);
    console.error('❌ [deleteTeacherArchived] Error status:', error.response?.status);
    console.error('❌ [deleteTeacherArchived] Error data:', error.response?.data);
    console.error('❌ [deleteTeacherArchived] Error headers:', error.response?.headers);
    console.error('❌ [deleteTeacherArchived] Error config:', error.config);
    console.error('❌ [deleteTeacherArchived] Full error:', error);
    throw error;
  }
}

export async function restoreClassFromSoftDelete(data) {
  try {
    const response = await instance.post('/classes/restore/csd', {
      deletedClassId: data.deletedClassId
    });
    return response.data;
  } catch (error) {
    console.error('Error restoring class:', error);
    throw error;
  }
}

// export async function softDeleteTeacher(teacherid) {
//   try {
//     await instance.delete(`/teachers/${teacherid}/csd`);
//   } catch (error) {
//     console.error('Error soft deleting teacher:', error);
//     throw error;
//   }
// }

// export async function softDeleteTeacher(teacherid) {
//   try {
//     console.log('🔵 [softDeleteTeacher] Starting soft delete...');
//     console.log('🔵 [softDeleteTeacher] Teacher ID:', teacherid);

//     const response = await instance.delete(`/teachers/${teacherid}/csd`);

//     console.log('✅ [softDeleteTeacher] Success!');
//     console.log('✅ [softDeleteTeacher] Status:', response.status);
//     console.log('✅ [softDeleteTeacher] Response:', response);

//     return response;
//   } catch (error) {
//     console.error('❌ [softDeleteTeacher] Error occurred');
//     console.error('❌ [softDeleteTeacher] Error message:', error.message);
//     console.error('❌ [softDeleteTeacher] Error status:', error.response?.status);
//     console.error('❌ [softDeleteTeacher] Error data:', error.response?.data);
//     console.error('❌ [softDeleteTeacher] Error headers:', error.response?.headers);
//     console.error('❌ [softDeleteTeacher] Full error:', error);
//     throw error;
//   }
// }


// gets all classes associated with a  teacher in a school 
export async function getClassesByTeacherId(teacherid) {
  try {
    const response = await instance.get(`/teachers/${teacherid}/classes/csd`);
    return response.data;
  } catch (error) {
    console.error('Error fetching students for class:', error);
    throw error;
  }
}

// export function removeOrUpdateTeacherInClass(classId, teacherId, data) {
//   return instance.patch(`/classes/${classId}/teachers/${teacherId}/remove/csd`, data)
//     .then((response) => {
//       console.log(response)
//       return response.data;
//     });
// }

/**
 * Remove a teacher from a shared class
 * @param {string} classId - ID of the class
 * @param {string} teacherId - ID of the teacher
 * @returns {Promise}
 */
export function removeFromSharedClass(classId, teacherId) {
  console.log(`Attempting to remove teacher ${teacherId} from shared class ${classId}`);

  return instance.delete(`/classes/${classId}/teachers/${teacherId}/shared`)
    .then(response => {
      console.log(`Successfully removed teacher ${teacherId} from shared class ${classId}`);
      return response;
    })
    .catch(error => {
      console.error(`Error removing teacher ${teacherId} from shared class ${classId}.`, error);
      throw error;
    });
}

/**
 * Get all teachers that a class has been shared with
 *
 * @param {string} classId - The ID of the class to get shared teachers for
 * @returns {Promise} Promise that resolves to an array of teacher objects
 */
export function getSharedTeachersByClassId(classId) {
  return instance
    .get(`/classes/${classId}/shared-teachers`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error fetching shared teachers:', error);
      throw error;
    });
}

/**
 * Get detailed shared class information including SharedClass IDs and teacher details
 *
 * @param {string} classId - The ID of the class to get shared details for
 * @returns {Promise} Promise that resolves to an array of objects with sharedClassId and teacher data
 */
export function getSharedClassDetailsByClassId(classId) {
  return instance
    .get(`/classes/${classId}/shared-details`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error fetching shared class details:', error);
      throw error;
    });
}

/**
 * Remove or replace the class owner
 * @param {string} classId - ID of the class
 * @param {string|null} newClassOwnerId - New owner ID, or null/empty to remove the current owner
 * @returns {Promise}
 */
export function removeOrReplaceClassOwner(classId, newClassOwnerId) {
  console.log(`Attempting to ${newClassOwnerId ? 'replace' : 'remove'} class owner for class ${classId}`);

  return instance.patch(`/classes/${classId}/owner`, { newClassOwnerId })
    .then(response => {
      if (newClassOwnerId) {
        console.log(`Successfully replaced class owner for class ${classId} with ${newClassOwnerId}`);
      } else {
        console.log(`Successfully removed class owner for class ${classId}`);
      }
      return response;
    })
    .catch(error => {
      console.error(`Error ${newClassOwnerId ? 'replacing' : 'removing'} class owner for class ${classId}.`, error);
      throw error;
    });
}

/**
 * Bulk remove or replace class owners for multiple classes
 * @param {string[]} classIds - Array of class IDs to update
 * @param {string|null} newClassOwnerId - New owner ID, or null/empty to remove the current owners
 * @returns {Promise<{successful: string[], failed: Array<{classId: string, error: string}>}>}
 */
export function bulkRemoveOrReplaceClassOwner(classIds, newClassOwnerId) {
  const action = newClassOwnerId ? 'replace' : 'remove';
  console.log(`Attempting to ${action} class owners for ${classIds.length} classes:`, classIds);

  const requestBody = {
    classIds,
    ...(newClassOwnerId && { newClassOwnerId })
  };

  return instance.patch('/classes/bulk-owner', requestBody)
    .then(response => {
      const { successful, failed } = response.data;

      // Log success summary
      if (successful.length > 0) {
        console.log(`Successfully ${action}d class owners for ${successful.length} classes:`, successful);
        if (newClassOwnerId) {
          console.log(`New owner ID: ${newClassOwnerId}`);
        }
      }

      // Log failure summary
      if (failed.length > 0) {
        console.warn(`Failed to ${action} class owners for ${failed.length} classes:`);
        failed.forEach(failure => {
          console.error(`- Class ${failure.classId}: ${failure.error}`);
        });
      }

      return response.data;
    })
    .catch(error => {
      console.error(`Error during bulk ${action} class owners operation for classes:`, classIds, error);
      throw error;
    });
}

/**
 * Replace the class creator with a new teacher
 * @param {string} classId - ID of the class
 * @param {string} newTeacherId - ID of the new teacher (creator)
 * @returns {Promise}
 */
export function replaceClassCreator(classId, newTeacherId) {
  console.log(`Attempting to replace class creator for class ${classId} with new teacher ${newTeacherId}`);

  return instance.patch(`/classes/${classId}/creator`, { newTeacherId })
    .then(response => {
      console.log(`Successfully replaced class creator for class ${classId} with new teacher ${newTeacherId}`);
      return response;
    })
    .catch(error => {
      console.error(`Error replacing class creator for class ${classId} with teacher ${newTeacherId}.`, error);
      throw error;
    });
}

// @Mick 
// Filters can be passed in the following format:
// {
//   "dateFrom": "2024-08-15", (start date)
//   "excludedCountryId": "74bb2897-dbbe-41e3-b547-caee866545cf", (countrys you dont want included)
//   "assessmentId": "68ce3a92-73e0-4158-9c08-31bff6246d23", (assessmentid of assessment)
//   "gradeLevel": "grade_level1" (grade_level1 OR grade_level2)
// }

export function fetchSchoolAssessmentSummary(filters) {
  return instance
    .post('/school-assessment-summary/csd', filters)
    .then((response) => {
      console.log('School assessment summary data:', response.data);
      return response.data;
    })
    .catch((error) => {
      console.error('Error fetching school assessment summary:', error);
      throw error;
    });
}


/**
 * Fetch all classes for a school
 * @param {string} schoolId - The ID of the school
 * @returns {Promise<any[]>} - Promise resolving to the list of classes for the school
 */
export function getClassesByAssessmentId(
  assessmentId,
  schoolId,
  timeframe = null
) {
  let url = `/schools/${schoolId}/classes/by-assessment/${assessmentId}`;

  // Add timeframe as query parameters if provided
  if (timeframe) {
    url += `?start=${timeframe.start}&end=${timeframe.end}`;
  }

  return instance
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching classes for assessment:", error);
      throw error;
    });
}


// export function getClassesAssessmentResults(classIds, assessmentId) {
//   return instance
//     .post("/classes/assessments/results/v2", {
//       classIds: classIds,
//       assessmentId: assessmentId,
//     })
//     .then((response) => {
//       console.log(response)
//       return response.data;
//     })
//     .catch((error) => {
//       // Handle any errors here
//       console.error("Error fetching class assessment results:", error);
//       throw error; // or return an error message, depending on your error handling strategy
//     });
// }

export function getClassesAssessmentResults(classIds, assessmentId) {
  return instance
    .post("/classes/assessments/results/v4", {
      classIds: classIds,
      assessmentId: assessmentId,
    })
    .then((response) => {
      console.log(response)
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching class assessment results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

export function postAladdinExportAuditLog(
  teacherid,
  schoolId,
  assessmentName,
  assessmentId,
  classids,
  classNames,
  exportType
) {
  // Log the data being passed to the function
  console.log("Preparing to send request with the following data:");
  console.log("teacherid:", teacherid);
  console.log("schoolId:", schoolId);
  console.log("assessmentName:", assessmentName);
  console.log("assessmentId:", assessmentId);
  console.log("classids", classids);
  console.log("classNames", classNames);

  return instance
    .post("/aladdinresultsexportauditlogs", {
      teacherid: teacherid,
      schoolId: schoolId,
      assessmentName: assessmentName,
      assessmentId: assessmentId,
      classids: classids,
      classNames: classNames,
      exportType: exportType,
    })
    .then((response) => {
      // Log the response data
      console.log("Received response:", response.data);
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

export function sendAladdinResultsEmail(teacherEmail, teacherName, emailPayload) {
  console.log("📨 Requesting email send with payload:", emailPayload);

  return instance
    .post("/send-aladdin-results-email", {
      teacherEmail,
      teacherName,
      ...emailPayload, // Spread the already prepared payload (processed data)
    })
    .then((response) => {
      console.log("✅ Email request sent successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("❌ Error sending email:", error);
      throw error;
    });
}

/**
 * Create a new assessment reminder
 * 
 * @param reminderData - Object containing reminder information
 * @param reminderData.assessmentid - ID of the assessment to be reminded about
 * @param reminderData.assessmentName - Name of the assessment (e.g., "Jnr End of Year Assessment")
 * @param reminderData.academicYear - Academic year in format "YY/YY" (e.g., "24/25")
 * @param reminderData.email - (Optional) Override email address to send notifications to
 * @param reminderData.name - (Optional) Override teacher name for the notification
 * 
 * @returns Promise with the created reminder data
 * 
 * @example
 * // Basic usage with required fields only
 * createAssessmentReminder({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   assessmentName: 'Jnr End of Year Assessment',
 *   academicYear: '24/25'
 * });
 * 
 * // With custom email and name
 * createAssessmentReminder({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   assessmentName: 'Jnr End of Year Assessment',
 *   academicYear: '24/25',
 *   email: 'custom@example.com',
 *   name: 'Custom Teacher Name'
 * });
 */
export const createAssessmentReminder = async (reminderData) => {
  try {
    const response = await instance.post('/assessment-reminders', reminderData);
    console.log("reminderData", reminderData);
    return response.data;
  } catch (error) {
    console.error('Error creating assessment reminder:', error);
    throw error;
  }
};

/**
 * Get all reminders for the currently authenticated teacher
 * 
 * @returns Promise with an array of reminder objects
 * 
 * @example
 * // Get all reminders for the current user
 * const myReminders = await getTeacherReminders();
 */
export const getTeacherReminders = async () => {
  try {
    const response = await instance.get('/assessment-reminders');
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher reminders:', error);
    throw error;
  }
};

/**
 * Get a specific reminder by ID
 * 
 * @param reminderId - ID of the reminder to retrieve
 * @returns Promise with the reminder object
 * 
 * @example
 * // Get a specific reminder
 * const reminder = await getAssessmentReminder('123e4567-e89b-12d3-a456-426614174000');
 */
export const getAssessmentReminder = async (reminderId) => {
  try {
    const response = await instance.get(`/assessment-reminders/${reminderId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching reminder with ID ${reminderId}:`, error);
    throw error;
  }
};

/**
 * Delete a specific reminder
 * 
 * @param reminderId - ID of the reminder to delete
 * @returns Promise resolving when deletion is complete
 * 
 * @example
 * // Delete a specific reminder
 * await deleteAssessmentReminder('123e4567-e89b-12d3-a456-426614174000');
 */
export const deleteAssessmentReminder = async (reminderId) => {
  try {
    await instance.delete(`/assessment-reminders/${reminderId}`);
    return true;
  } catch (error) {
    console.error(`Error deleting reminder with ID ${reminderId}:`, error);
    throw error;
  }
};

/**
 * Get count of reminders matching specific criteria (admin function)
 * 
 * @param where - Filter criteria in Loopback format
 * @returns Promise with the count of matching reminders
 * 
 * @example
 * // Count all pending reminders for a specific assessment
 * const count = await countAssessmentReminders({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   notificationSent: false
 * });
 */
export const countAssessmentReminders = async (where = {}) => {
  try {
    // Serialize where object for URL params
    const params = Object.keys(where).length ? { where: JSON.stringify(where) } : {};
    const response = await instance.get('/assessment-reminders/count', { params });
    return response.data.count;
  } catch (error) {
    console.error('Error counting assessment reminders:', error);
    throw error;
  }
};

/**
 * Mark assessment results as ready and send notifications (admin function)
 * Triggers emails to all teachers who requested reminders for this assessment
 * 
 * @param notifyData - Object containing notification parameters
 * @param notifyData.assessmentid - ID of the assessment that's now ready
 * @param notifyData.academicYear - Academic year in format "YY/YY" (e.g., "24/25")
 * @returns Promise with the notification results (count of total and sent)
 * 
 * @example
 * // Mark End of Year assessment results as ready for 24/25
 * const result = await markAssessmentResultsReady({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   academicYear: '24/25'
 * });
 * // Result: { message: "Sent 15 of 15 notifications", total: 15, sent: 15 }
 */
export const markAssessmentResultsReady = async (notifyData) => {
  try {
    const response = await instance.post('/admin/assessment-reminders/notify', notifyData);
    return response.data;
  } catch (error) {
    console.error('Error marking assessment results as ready:', error);
    throw error;
  }
};


/**
 * Fetch trial information for a specific school
 *
 * @param {string} schoolid - The unique identifier for the school
 * @returns {Promise} Promise resolving to trial data for the school
 */
export function getTrialBySchoolId(schoolid) {
  return instance.get(`/trialists/school/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Update trial information for a specific school
 *
 * @param {string} schoolid - The unique identifier for the school
 * @param {Object} updates - Object containing fields to update
 * @returns {Promise} Promise resolving to updated trial data
 */
export function updateTrialBySchoolId(schoolid, updates) {
  return instance.patch(`/trialists/school/${schoolid}/update`, updates).then((response) => {
    return response.data;
  });
}

// /**
//  * Apply a 7-day extension to a school's trial
//  *
//  * @param {string} schoolid - The unique identifier for the school
//  * @returns {Promise} Promise resolving to updated trial data
//  */
// export function applyTrialExtension(schoolid) {
//   return instance.patch(`/trialists/school/${schoolid}/extension`).then((response) => {
//     return response.data;
//   });
// }


/**
 * Get the current ALPACA Lead for a school
 * @param {string} schoolid - The school ID
 * @returns {Promise} - Returns the current ALPACA Lead teacher or null
 */
export function getCurrentAlpacaLead(schoolid) {
  return instance
    .get(`/schools/${schoolid}/alpaca-lead`)
    .then((response) => {
      return response.data;
    });
}


/**
 * Get all country-level screener settings for a school
 * 
 * @param {string} schoolid - School ID to get country screeners for
 * @returns Array of CountryScreener objects for the school's country
 */
export function getCountryScreeners(schoolid) {
  return instance.get(`/countryscreeners/by-school/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Get all country-level screener settings by country ID
 * 
 * @param {string} countryid - Country ID to get screeners for
 * @returns Array of CountryScreener objects with windowStatus, available, and windowConfigured
 */
export function getCountryScreenersByCountryId(countryid) {
  return instance.get(`/countryscreeners/by-country/${countryid}`).then((response) => {
    return response.data;
  });
}

export function getTrialScreenerAccessByCountry(countryid) {
  return instance
    .get(`/trial-screener-access/countries/${countryid}`)
    .then((response) => response.data);
}

export function updateTrialScreenerAccess(countryid, assessmentid, enabled) {
  return instance
    .patch(
      `/trial-screener-access/countries/${countryid}/assessments/${assessmentid}`,
      { enabled }
    )
    .then((response) => response.data);
}

/**
 * Get all school-level screener settings for a school
 * 
 * @param {string} schoolid - School ID to get screeners for
 * @returns Array of SchoolScreener objects for the school
 */
export function getSchoolScreeners(schoolid) {
  return instance.get(`/schoolscreeners/by-school/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Get country ID for a specific school
 *
 * @param {string} schoolId - The ID of the school
 * @returns Promise that resolves to either {schoolId: string, countryId: string} or {message: string}
 */
export function getCountryId(schoolId) {
  return instance
    .get(`/schools/${schoolId}/country-id`)
    .then((response) => {
      return response.data;
    });
}


/**
 * Create or update a country-level screener setting
 * 
 * @param {string} countryid - Country ID
 * @param {string} assessmentid - Assessment ID to manage
 * @param {object} data - Screener settings
 * @param {boolean} data.active - Whether the screener is active
 * @param {string} data.created_by - User who created the record
 * @param {string} data.updated_by - User who updated the record
 * @param {Date} [data.dateopened] - Optional opening date
 * @param {Date} [data.dateclosed] - Optional closing date
 * @returns Updated CountryScreener object with windowStatus, available, and windowConfigured
 */
export function upsertCountryScreener(countryid, assessmentid, data) {
  // Remove null values that cause API validation errors
  const cleanData = { ...data };
  if (cleanData.dateclosed === null) delete cleanData.dateclosed;
  if (cleanData.dateopened === null) delete cleanData.dateopened;

  return instance.patch(`/countryscreeners/by-country/${countryid}/${assessmentid}`, cleanData).then((response) => {
    return response.data;
  });
}

/**
 * Create or update a school-level screener setting
 * 
 * @param {string} schoolid - School ID
 * @param {string} assessmentid - Assessment ID to manage
 * @param {object} data - Screener settings
 * @param {boolean} data.active - Whether the screener is active
 * @param {string} data.created_by - User who created the record
 * @param {string} data.updated_by - User who updated the record
 * @param {Date} [data.dateopened] - Optional opening date
 * @param {Date} [data.dateclosed] - Optional closing date
 * @returns Updated SchoolScreener object
 */
export function upsertSchoolScreener(schoolid, assessmentid, data) {
  return instance.patch(`/schoolscreeners/${schoolid}/${assessmentid}`, data).then((response) => {
    return response.data;
  });
}

/**
 * Get today's stats by grade - returns array of schools with today's activity
 *
 * @param {object} filters - Filter options
 * @param {string} filters.classDateFrom - Class date filter (optional)
 * @param {string} filters.assessmentDateFrom - Assessment date filter (optional) 
 * @param {boolean} filters.purchasedOnly - Include only purchased schools (optional, default: true)
 * @returns Array of schools with today's grade-level stats
 */
export function getTodayStatsByGrade(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classDateFrom) params.append('classDateFrom', filters.classDateFrom);
  if (filters.assessmentDateFrom) params.append('assessmentDateFrom', filters.assessmentDateFrom);
  if (filters.purchasedOnly !== undefined) params.append('purchasedOnly', filters.purchasedOnly);

  return instance
    .get(`/grade-reports/today-stats?${params}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get overall stats by grade - returns array of schools with overall activity
 *
 * @param {object} filters - Filter options
 * @param {string} filters.classDateFrom - Class date filter (optional)
 * @param {string} filters.assessmentDateFrom - Assessment date filter (optional)
 * @param {boolean} filters.purchasedOnly - Include only purchased schools (optional, default: true)
 * @returns Array of schools with overall grade-level stats
 */
export function getOverallStatsByGrade(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classDateFrom) params.append('classDateFrom', filters.classDateFrom);
  if (filters.assessmentDateFrom) params.append('assessmentDateFrom', filters.assessmentDateFrom);
  if (filters.purchasedOnly !== undefined) params.append('purchasedOnly', filters.purchasedOnly);

  return instance
    .get(`/grade-reports/overall-stats?${params}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get school stats by grade - returns detailed school-by-school breakdown
 *
 * @param {object} filters - Filter options
 * @param {string} filters.classDateFrom - Class date filter (optional)
 * @param {string} filters.assessmentDateFrom - Assessment date filter (optional)
 * @param {boolean} filters.purchasedOnly - Include only purchased schools (optional, default: true)
 * @param {string} filters.screeningStatus - Filter by screening status: 'STARTED', 'NOT_STARTED' (optional)
 * @returns Array of schools with detailed grade-level breakdown
 */
export function getSchoolStatsByGrade(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classDateFrom) params.append('classDateFrom', filters.classDateFrom);
  if (filters.assessmentDateFrom) params.append('assessmentDateFrom', filters.assessmentDateFrom);
  if (filters.purchasedOnly !== undefined) params.append('purchasedOnly', filters.purchasedOnly);
  if (filters.screeningStatus) params.append('screeningStatus', filters.screeningStatus);

  return instance
    .get(`/grade-reports/school-stats?${params}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get schools that haven't started screening - returns array of not started schools
 *
 * @param {object} filters - Filter options
 * @param {string} filters.classDateFrom - Class date filter (optional)
 * @param {string} filters.assessmentDateFrom - Assessment date filter (optional)
 * @param {boolean} filters.purchasedOnly - Include only purchased schools (optional, default: true)
 * @returns Array of schools that haven't started screening
 */
export function getNotStartedByGrade(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classDateFrom) params.append('classDateFrom', filters.classDateFrom);
  if (filters.assessmentDateFrom) params.append('assessmentDateFrom', filters.assessmentDateFrom);
  if (filters.purchasedOnly !== undefined) params.append('purchasedOnly', filters.purchasedOnly);

  return instance
    .get(`/grade-reports/not-started?${params}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get schools with assigned screeners - returns array of schools with screener assignments
 *
 * @param {object} filters - Filter options
 * @param {string} filters.classDateFrom - Class date filter (optional)
 * @param {string} filters.assessmentDateFrom - Assessment date filter (optional)
 * @param {boolean} filters.purchasedOnly - Include only purchased schools (optional, default: true)
 * @returns Array of schools with assigned screeners (school intentions)
 */
export function getAssignedScreeners(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classDateFrom) params.append('classDateFrom', filters.classDateFrom);
  if (filters.assessmentDateFrom) params.append('assessmentDateFrom', filters.assessmentDateFrom);
  if (filters.purchasedOnly !== undefined) params.append('purchasedOnly', filters.purchasedOnly);

  return instance
    .get(`/grade-reports/assigned-screeners?${params}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get grade reports summary - returns combined summary data
 *
 * @param {object} filters - Filter options
 * @param {string} filters.classDateFrom - Class date filter (optional)
 * @param {string} filters.assessmentDateFrom - Assessment date filter (optional)
 * @param {boolean} filters.purchasedOnly - Include only purchased schools (optional, default: true)
 * @returns Summary object with all grade report data
 */
export function getGradeReportsSummary(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classDateFrom) params.append('classDateFrom', filters.classDateFrom);
  if (filters.assessmentDateFrom) params.append('assessmentDateFrom', filters.assessmentDateFrom);
  if (filters.purchasedOnly !== undefined) params.append('purchasedOnly', filters.purchasedOnly);

  return instance
    .get(`/grade-reports/summary?${params}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all countries from the server
 *
 * @returns {Promise<Array>} Array of all country objects
 */
export function getCountries() {
  return instance.get('/countries').then((response) => {
    return response.data;
  });
}

/**
 * Update trial status for multiple classes
 *
 * @param {string[]} classIds - Array of class IDs to update
 * @param {boolean} isTrialClass - Whether to set classes as trial (true) or regular (false)
 * @returns {Promise<{updated: number, failed: Array<{classId: string, error: string}>}>} 
 *          Promise that resolves to object containing count of updated classes and any failures
 */
export function updateTrialStatusBatch(classIds, isTrialClass) {
  return instance
    .patch("/classes/batch/trial-status", {
      classIds: classIds,
      isTrialClass: isTrialClass
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        throw new Error(
          error.response.data?.message ||
          `Server error: ${error.response.status}`
        );
      } else if (error.request) {
        // Request was made but no response received
        throw new Error("Network error: No response from server");
      } else {
        // Something else happened
        throw new Error(`Request error: ${error.message}`);
      }
    });
}

/**
 * Get all students belonging to a specific school
 *
 * @param {string} schoolId - The UUID of the school
 * @returns {Promise<Array>} Array of students with their class information
 */
export function getStudentsBySchoolId(schoolId) {
  return instance.get(`/students/by-school/${schoolId}`).then((response) => {
    return response.data;
  });
}

/**
 * Bulk update grade levels for multiple classes
 *
 * @param {string[]} classIds - Array of class IDs to update (UUIDs as strings)
 * @param {number} gradeLevel - Target grade level (1, 2, 3, 4, etc.)
 * @returns {Promise} Promise that resolves to the bulk update result
 */
export async function bulkUpdateClassGrades(classIds, gradeLevel) {
  try {
    const response = await instance.patch("/classes/bulk-grade-update", {
      classIds,
      gradeLevel
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data?.error?.message || error.response.data?.message || 'Unknown server error';
      throw new Error(`Server Error (${error.response.status}): ${errorMessage}`);
    } else if (error.request) {
      throw new Error('Network Error: No response from server');
    } else {
      throw new Error(`Request Error: ${error.message}`);
    }
  }
}

/**
 * Get all purchased entries for a specific school
 *
 * @param {string} schoolid - The school ID to filter purchases by
 * @param {object} filterOptions - Optional LoopBack filter parameters (limit, offset, order, where, etc.)
 * @returns Promise that resolves to array of purchased entries for the school
 */
export function getPurchasesBySchool(schoolid, filterOptions = {}) {
  let url = `/purchased/school/${schoolid}`;

  // Add filter parameters as query string if provided
  // Remove the extra "filter" wrapper - LoopBack expects the filter object directly
  if (Object.keys(filterOptions).length > 0) {
    const filterParam = encodeURIComponent(JSON.stringify(filterOptions));
    url += `?filter=${filterParam}`;
  }

  return instance
    .get(url)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update purchased entries for a specific school
 *
 * @param {string} schoolid - The school ID to update purchases for
 * @param {object} updateData - The data to update (can include any Purchased model fields)
 * @param {object} whereClause - Optional additional where conditions to narrow down which records to update
 * @returns Promise that resolves to count object showing how many records were updated
 */
export function updatePurchasesBySchool(schoolid, updateData, whereClause = {}) {
  let url = `/purchased/school/${schoolid}`;

  // Add where clause as query parameter if provided
  if (Object.keys(whereClause).length > 0) {
    const whereParam = encodeURIComponent(JSON.stringify(whereClause));
    url += `?where=${whereParam}`;
  }

  return instance
    .patch(url, updateData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new purchased entry for a specific school
 *
 * @param {string} schoolid - The school ID to create the purchase for
 * @param {object} purchaseData - The purchase data (excluding id, schoolid, created_date, updated_date)
 * @returns Promise that resolves to the created purchased entry
 */
export function createPurchaseForSchool(schoolid, purchaseData) {
  return instance
    .post(`/purchased/school/${schoolid}`, purchaseData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete a purchased entry by its ID
 *
 * @param {string} purchaseId - The ID of the purchase to delete
 * @returns Promise that resolves when the deletion is complete
 */
export function deletePurchaseById(purchaseId) {
  return instance
    .delete(`/purchased/${purchaseId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Mark a student as repeating and archive their assessments
 *
 * @param {string} studentId - UUID of the student
 * @param {string} academicYear - Current academic year (e.g., "2025/26")
 * @param {string} teacherId - UUID of the teacher marking the student
 * @param {string} teacherName - Name of the teacher marking the student (optional)
 * @param {string} reason - Reason for archiving (optional, defaults to "repeat")
 * @returns Promise with success status and archived count
 */
export function markStudentAsRepeat(studentId, academicYear, teacherId, teacherName = null, reason = "repeat") {
  const payload = {
    studentId: studentId,
    academicYear: academicYear,
    teacherId: teacherId,
    reason: reason
  };

  // Only include teacherName if provided
  if (teacherName) {
    payload.teacherName = teacherName;
  }

  return instance
    .post("/students/mark-repeat", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error marking student as repeat:", error);
      throw error;
    });
}

/**
 * Get all archived assessment instances for a student
 *
 * @param {string} studentId - UUID of the student
 * @param {string} academicYear - Optional: filter by specific academic year (e.g., "2024/25")
 * @returns Promise with array of archived assessment instances
 */
export function getArchivedAssessments(studentId, academicYear = null) {
  let url = `/archived-assessment-instances/student/${studentId}`;

  if (academicYear) {
    url += `?academicYear=${encodeURIComponent(academicYear)}`;
  }

  return instance.get(url).then((response) => {
    return response.data;
  });
}

/**
 * Get detailed results for archived assessment instances
 *
 * @param {string} studentId - UUID of the student
 * @param {string[]} assessmentInstanceIds - Array of original assessment instance IDs
 * @returns Promise with detailed results including tasks and scores
 */
export function getArchivedAssessmentResults(studentId, assessmentInstanceIds) {
  const params = new URLSearchParams();
  params.append('studentId', studentId);

  // Add each assessment instance ID as a separate parameter
  assessmentInstanceIds.forEach(id => {
    params.append('assessmentInstanceIds', id);
  });

  return instance
    .get(`/archived-assessment-instances/results/students?${params.toString()}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Convenience function to get both archived assessments and their results
 *
 * @param {string} studentId - UUID of the student
 * @param {string} academicYear - Optional: filter by specific academic year
 * @returns Promise with object containing both lists and results
 */
export function getArchivedAssessmentsWithResults(studentId, academicYear = null) {
  return getArchivedAssessments(studentId, academicYear)
    .then((archivedAssessments) => {
      if (archivedAssessments.length === 0) {
        return {
          assessments: [],
          results: []
        };
      }

      // Extract the original assessment instance IDs
      const assessmentInstanceIds = archivedAssessments.map(
        assessment => assessment.assessmentinstanceid
      );

      // Get detailed results
      return getArchivedAssessmentResults(studentId, assessmentInstanceIds)
        .then((results) => {
          return {
            assessments: archivedAssessments,
            results: results
          };
        });
    });
}


/**
 * Get deleted answers for a specific assessment instance
 *
 * @param {string} assessmentInstanceId - The assessment instance ID
 * @returns {Promise} Array of deleted answers with task details
 */
// export function getDeletedAnswersByAssessmentInstance(assessmentInstanceId) {
//   return instance
//     .get(`/assessment-instances/${assessmentInstanceId}/deleted-answers`)
//     .then((response) => {
//       console.log('Deleted answers:', response.data);
//       return response.data;
//     })
//     .catch((error) => {
//       console.error('Error fetching deleted answers:', error);
//       throw error;
//     });
// }

/**
 * Get both active and deleted answers for a specific assessment instance
 *
 * @param {string} assessmentInstanceId - The assessment instance ID
 * @returns {Promise} Object containing activeAnswers and deletedAnswers arrays
 */
// export function getAllAnswersByAssessmentInstance(assessmentInstanceId) {
//   return instance
//     .get(`/assessment-instances/${assessmentInstanceId}/all-answers`)
//     .then((response) => {
//       console.log('All answers (active + deleted):', response.data);
//       return response.data;
//     })
//     .catch((error) => {
//       console.error('Error fetching all answers:', error);
//       throw error;
//     });
// }

/**
 * Create deletion records for multiple answers
 *
 * @param {string} teacherid - The teacher ID performing the deletion
 * @param {string[]} answerids - Array of answer IDs to mark as deleted
 * @param {string} answerdeletionreasonid - The deletion reason ID
 * @param {string} [deletionreason] - Optional custom deletion reason text
 * @returns {Promise} Array of created AnswerDeleted records
 */
export function createAnswerDeletionRecords(teacherid, answerids, answerdeletionreasonid, deletionreason = null) {
  const payload = {
    teacherid,
    answerids,
    answerdeletionreasonid,
    ...(deletionreason && { deletionreason })
  };

  return instance
    .post('/answers-deleted', payload)
    .then((response) => {
      console.log('Answer deletion records created:', response.data);
      return response.data;
    })
    .catch((error) => {
      console.error('Error creating answer deletion records:', error);
      throw error;
    });
}

/**
 * Get deleted answers with additional filtering and sorting options
 *
 * @param {string} assessmentInstanceId - The assessment instance ID
 * @param {Object} options - Additional options for filtering/sorting
 * @param {string} [options.sortBy] - Field to sort by (taskOrder, dateDeleted, score)
 * @param {string} [options.sortOrder] - Sort order (asc, desc)
 * @param {number} [options.minScore] - Minimum score filter
 * @param {number} [options.maxScore] - Maximum score filter
 * @returns {Promise} Filtered and sorted array of deleted answers
 */
// export function getDeletedAnswersWithOptions(assessmentInstanceId, options = {}) {
//   return getDeletedAnswersByAssessmentInstance(assessmentInstanceId)
//     .then((deletedAnswers) => {
//       let filteredAnswers = [...deletedAnswers];

//       // Apply score filters if provided
//       if (options.minScore !== undefined) {
//         filteredAnswers = filteredAnswers.filter(answer =>
//           answer.score !== null && answer.score >= options.minScore
//         );
//       }

//       if (options.maxScore !== undefined) {
//         filteredAnswers = filteredAnswers.filter(answer =>
//           answer.score !== null && answer.score <= options.maxScore
//         );
//       }

//       // Apply custom sorting if provided
//       if (options.sortBy) {
//         filteredAnswers.sort((a, b) => {
//           let aValue = a[options.sortBy];
//           let bValue = b[options.sortBy];

//           // Handle null/undefined values
//           if (aValue == null && bValue == null) return 0;
//           if (aValue == null) return 1;
//           if (bValue == null) return -1;

//           // Handle date strings
//           if (options.sortBy === 'dateDeleted' || options.sortBy === 'submitted') {
//             aValue = new Date(aValue);
//             bValue = new Date(bValue);
//           }

//           const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
//           return options.sortOrder === 'desc' ? -comparison : comparison;
//         });
//       }

//       return filteredAnswers;
//     });
// }

/**
 * Get summary statistics for deleted answers in an assessment instance
 *
 * @param {string} assessmentInstanceId - The assessment instance ID
 * @returns {Promise} Object containing summary statistics
 */
// export function getDeletedAnswersSummary(assessmentInstanceId) {
//   return getDeletedAnswersByAssessmentInstance(assessmentInstanceId)
//     .then((deletedAnswers) => {
//       if (deletedAnswers.length === 0) {
//         return {
//           totalDeleted: 0,
//           averageScore: null,
//           totalDuration: 0,
//           taskBreakdown: {},
//           deletionDates: []
//         };
//       }

//       const validScores = deletedAnswers
//         .map(answer => answer.score)
//         .filter(score => score !== null && score !== undefined);

//       const averageScore = validScores.length > 0
//         ? validScores.reduce((sum, score) => sum + score, 0) / validScores.length
//         : null;

//       const totalDuration = deletedAnswers.reduce(
//         (sum, answer) => sum + (answer.duration || 0),
//         0
//       );

//       // Group by task
//       const taskBreakdown = deletedAnswers.reduce((breakdown, answer) => {
//         const taskName = answer.taskName || 'Unknown Task';
//         if (!breakdown[taskName]) {
//           breakdown[taskName] = {
//             count: 0,
//             totalScore: 0,
//             validScoreCount: 0
//           };
//         }
//         breakdown[taskName].count++;
//         if (answer.score !== null && answer.score !== undefined) {
//           breakdown[taskName].totalScore += answer.score;
//           breakdown[taskName].validScoreCount++;
//         }
//         return breakdown;
//       }, {});

//       // Calculate average scores per task
//       Object.keys(taskBreakdown).forEach(taskName => {
//         const task = taskBreakdown[taskName];
//         task.averageScore = task.validScoreCount > 0
//           ? task.totalScore / task.validScoreCount
//           : null;
//       });

//       const deletionDates = deletedAnswers
//         .map(answer => answer.dateDeleted)
//         .filter(date => date)
//         .sort();

//       return {
//         totalDeleted: deletedAnswers.length,
//         averageScore: averageScore ? Math.round(averageScore * 100) / 100 : null,
//         totalDuration,
//         taskBreakdown,
//         deletionDates,
//         firstDeletion: deletionDates[0] || null,
//         lastDeletion: deletionDates[deletionDates.length - 1] || null
//       };
//     })
//     .catch((error) => {
//       console.error('Error calculating deleted answers summary:', error);
//       throw error;
//     });
// }

/**
 * Compare active vs deleted answers for an assessment instance
 *
 * @param {string} assessmentInstanceId - The assessment instance ID
 * @returns {Promise} Object with comparison data
 */
export function compareActiveVsDeletedAnswers(assessmentInstanceId) {
  return getAllAnswersByAssessmentInstance(assessmentInstanceId)
    .then((allAnswers) => {
      const { activeAnswers, deletedAnswers } = allAnswers;

      const activeStats = calculateAnswerStats(activeAnswers);
      const deletedStats = calculateAnswerStats(deletedAnswers);

      return {
        active: activeStats,
        deleted: deletedStats,
        comparison: {
          totalAnswers: activeStats.count + deletedStats.count,
          deletionRate: (deletedStats.count / (activeStats.count + deletedStats.count) * 100).toFixed(2),
          scoreDifference: activeStats.averageScore && deletedStats.averageScore
            ? (activeStats.averageScore - deletedStats.averageScore).toFixed(2)
            : null
        }
      };
    });
}

/**
 * Helper function to calculate statistics for an array of answers
 *
 * @param {Array} answers - Array of answer objects
 * @returns {Object} Statistics object
 */
function calculateAnswerStats(answers) {
  if (!answers || answers.length === 0) {
    return {
      count: 0,
      averageScore: null,
      totalDuration: 0,
      taskCount: 0
    };
  }

  const validScores = answers
    .map(answer => answer.score)
    .filter(score => score !== null && score !== undefined);

  const averageScore = validScores.length > 0
    ? validScores.reduce((sum, score) => sum + score, 0) / validScores.length
    : null;

  const totalDuration = answers.reduce(
    (sum, answer) => sum + (answer.duration || 0),
    0
  );

  const uniqueTasks = new Set(answers.map(answer => answer.taskId));

  return {
    count: answers.length,
    averageScore: averageScore ? Math.round(averageScore * 100) / 100 : null,
    totalDuration,
    taskCount: uniqueTasks.size
  };
}


/**
 * Find/delete orphaned assessment instances (no answers) within a date range.
 * Pass dryRun=true to preview; dryRun=false to actually delete.
 *
 * @returns {Promise<{found: number, deleted: number, dryRun: boolean, instances: Array}>}
 */
export function cleanupOrphanedInstances(startDate, endDate, assessmentIds, teacherId, dryRun = true) {
  return instance.delete('/assessment-instances/cleanup-orphaned', {
    data: { startDate, endDate, assessmentIds, teacherId, dryRun }
  }).then((response) => response.data);
}

/**
 * Find/force-complete incomplete assessment instances that have answers within a date range.
 * Pass dryRun=true to preview; dryRun=false to actually complete.
 *
 * @returns {Promise<{found: number, completed: number, dryRun: boolean, instances: Array}>}
 */
export function cleanupIncompleteInstances(startDate, endDate, assessmentIds, teacherId, dryRun = true) {
  return instance.patch('/assessment-instances/cleanup-incomplete', {
    startDate, endDate, assessmentIds, teacherId, dryRun
  }).then((response) => response.data);
}

/**
 * Perform comprehensive cleanup for a specific date range and assessment IDs
 * This combines finding and cleaning up both orphaned and incomplete instances
 * 
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format  
 * @param {string[]} assessmentIds - Array of assessment UUIDs to clean up
 * @param {string} teacherId - ID of the teacher performing the cleanup action
 * @param {boolean} [dryRun=false] - If true, only count what would be affected without making changes
 * @returns {Promise<{orphanedFound: number, orphanedDeleted: number, incompleteFound: number, incompleteCompleted: number}>} Cleanup results summary
 * 
 * @example
 * // Dry run to see what would be affected
 * const dryRunResult = await cleanupAssessmentPeriod(
 *   '2024-08-01', 
 *   '2024-12-01', 
 *   ['68ce3a92-73e0-4158-9c08-31bff6246d23', '927b2379-998c-4424-af56-1f82e0144765'],
 *   'teacher-uuid',
 *   true
 * );
 * console.log(`Would delete ${dryRunResult.orphanedFound} orphaned and complete ${dryRunResult.incompleteFound} incomplete instances`);
 * 
 * // Actual cleanup
 * const result = await cleanupAssessmentPeriod(
 *   '2024-08-01', 
 *   '2024-12-01', 
 *   ['68ce3a92-73e0-4158-9c08-31bff6246d23', '927b2379-998c-4424-af56-1f82e0144765'],
 *   'teacher-uuid',
 *   false
 * );
 * console.log(`Cleanup complete: deleted ${result.orphanedDeleted}, completed ${result.incompleteCompleted}`);
 */
export function cleanupAssessmentPeriod(startDate, endDate, assessmentIds, teacherId, dryRun = false) {
  return instance.post('/assessment-instances/cleanup-period', {
    startDate,
    endDate,
    assessmentIds,
    teacherId,
    dryRun
  }).then((response) => {
    return response.data;
  });
}

/**
 * WORKFLOW EXAMPLE - Complete assessment cleanup process
 * 
 * This shows how to use the functions together for a safe cleanup process:
 * 
 * async function performAssessmentCleanup() {
 *   const startDate = '2024-08-01';
 *   const endDate = '2024-12-01';
 *   const assessmentIds = [
 *     '68ce3a92-73e0-4158-9c08-31bff6246d23', 
 *     '927b2379-998c-4424-af56-1f82e0144765'
 *   ];
 *   const teacherId = 'your-teacher-uuid-here'; // Get this from your auth system
 * 
 *   try {
 *     // Step 1: Dry run to see what would be affected
 *     console.log('Running dry run to check what would be cleaned up...');
 *     const dryRun = await cleanupAssessmentPeriod(startDate, endDate, assessmentIds, teacherId, true);
 *     console.log('Dry run results:', dryRun);
 * 
 *     // Step 2: Review individual items if needed
 *     if (dryRun.orphanedFound > 0) {
 *       const orphaned = await findOrphanedAssessmentInstances(startDate, endDate, assessmentIds);
 *       console.log('Orphaned instances to be deleted:', orphaned);
 *     }
 * 
 *     if (dryRun.incompleteFound > 0) {
 *       const incomplete = await findIncompleteWithAnswers(startDate, endDate, assessmentIds);
 *       console.log('Incomplete instances to be completed:', incomplete);
 *     }
 * 
 *     // Step 3: Confirm and execute cleanup
 *     const confirmCleanup = window.confirm(
 *       `This will delete ${dryRun.orphanedFound} orphaned instances and complete ${dryRun.incompleteFound} incomplete instances. Continue?`
 *     );
 * 
 *     if (confirmCleanup) {
 *       console.log('Performing actual cleanup...');
 *       const result = await cleanupAssessmentPeriod(startDate, endDate, assessmentIds, teacherId, false);
 *       console.log('Cleanup completed:', result);
 *       
 *       alert(`Cleanup successful! Deleted ${result.orphanedDeleted} orphaned instances and completed ${result.incompleteCompleted} incomplete instances.`);
 *     }
 * 
 *   } catch (error) {
 *     console.error('Error during cleanup:', error);
 *     alert('Cleanup failed. Check console for details.');
 *   }
 * }
 */


/**
 * Bulk transition multiple classes using the new transition system
 *
 * @param {string[]} classIds - Array of class IDs to transition
 * @param {number} targetGradeLevel - Target grade level (1, 2, 3, 4, etc.)
 * @param {string} academicYear - Academic year (e.g., "25-26")
 * @param {string} reason - Transition reason
 * @returns {Promise} Promise that resolves to the bulk transition results
 */
export async function bulkTransitionClasses(classIds, targetGradeLevel, academicYear, reason = "Manual Grade Transition") {
  const results = [];

  for (const classId of classIds) {
    try {
      const response = await instance.post(`/classes/${classId}/transition`, {
        newGradeLevel: targetGradeLevel,
        newAcademicYear: academicYear,
        transitionReason: reason
      });

      results.push({
        classId,
        success: true,
        result: response.data
      });
    } catch (error) {
      results.push({
        classId,
        success: false,
        error: error.response?.data?.message || error.message
      });
    }
  }

  return {
    success: results.every(r => r.success),
    updated: results.filter(r => r.success).length,
    failed: results.filter(r => !r.success).length,
    results
  };
}

/**
 * Create a new class conversion method
 *
 * @param {string} teacherid 
 * @param {string} schoolid 
 * @param {string} transition_type 
 * @returns Created ClassConversionMethod object
 */
export function createClassConversionMethod(teacherid, schoolid, transition_type) {
  return instance
    .post("/classconversionmethods", {
      teacherid,
      schoolid,
      transition_type
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all class conversion methods
 *
 * @param {object} filter - Optional filter parameters
 * @returns Array of ClassConversionMethod objects
 */
export function getClassConversionMethods(filter) {
  const params = filter ? { filter: JSON.stringify(filter) } : {};

  return instance
    .get("/classconversionmethods", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Update an existing class conversion method by school ID
 *
 * @param {string} schoolid - School ID
 * @param {string} teacherid - New teacher ID
 * @param {string} transition_type - New transition type ('direct' or 'mix_reassign')
 * @returns Updated ClassConversionMethod object
 */
export function updateClassConversionMethod(schoolid, teacherid, transition_type) {
  return instance
    .patch(`/classconversionmethods/school/${schoolid}`, {
      teacherid,
      transition_type
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific class conversion method by school ID
 *
 * @param {string} schoolid - School ID
 * @returns ClassConversionMethod object or null if not found
 */
export function getClassConversionMethodBySchoolId(schoolid) {
  return instance
    .get(`/classconversionmethods/school/${schoolid}`)
    .then((response) => {
      return response.data; // Will be null if no record exists
    });
}

/**
 * Create a new assessment with associated tasks
 *
 * @param {Object} assessmentData - Assessment data
 * @param {string} assessmentData.name - Assessment name (required)
 * @param {string} [assessmentData.description] - Assessment description
 * @param {boolean} [assessmentData.standard] - Standard flag
 * @param {boolean} [assessmentData.active] - Active flag
 * @param {boolean} [assessmentData.grade_level1] - Grade level 1 flag
 * @param {boolean} [assessmentData.grade_level2] - Grade level 2 flag
 * @param {boolean} [assessmentData.task] - Task flag
 * @param {string} [assessmentData.startDate] - Start date (ISO string)
 * @param {string} [assessmentData.endDate] - End date (ISO string)
 * @param {boolean} [assessmentData.rti] - RTI flag
 * @param {string} [assessmentData.countryid] - Country ID
 * @param {Array} assessmentData.tasks - Array of task objects (required)
 * @param {string} assessmentData.tasks[].taskId - Task ID
 * @param {number} assessmentData.tasks[].order - Task order
 * @returns {Promise} Promise that resolves to the created assessment
 */
export function createAssessment(assessmentData) {
  return instance
    .post("/assessments", assessmentData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get assessments filtered by various criteria
 *
 * @param {Object} options - Filter options
 * @param {string} [options.countryid] - Country ID to filter by
 * @param {number} [options.grade_level] - Grade level (1, 2, etc.)
 * @param {boolean} [options.rti] - RTI flag
 * @param {boolean} [options.active] - Active flag (defaults to true on server)
 * @param {boolean} [options.standard] - Standard flag
 * @param {boolean} [options.task] - Task flag
 * @returns {Promise} Promise that resolves to array of filtered assessments
 */
export function getAssessmentScreener(options = {}) {
  // Build query parameters object, only including defined values
  const params = {};

  if (options.countryid !== undefined) {
    params.countryid = options.countryid;
  }

  if (options.grade_level !== undefined) {
    params.grade_level = options.grade_level;
  }

  if (options.rti !== undefined) {
    params.rti = options.rti;
  }

  if (options.active !== undefined) {
    params.active = options.active;
  }

  if (options.standard !== undefined) {
    params.standard = options.standard;
  }

  if (options.task !== undefined) {
    params.task = options.task;
  }

  return instance
    .get("/assessments/screener", { params })
    .then((response) => {
      return response.data;
    });
}

// =====================================================
// SCREENING WINDOW STATUS ENDPOINTS
// =====================================================

/**
 * Create new screening window status
 *
 * @param {Object} data - Screening window status data
 * @returns Promise with created screening window status
 */
export function createScreeningWindowStatus(data) {
  return instance
    .post("/screening-window-status", data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get screening window statuses by filters
 *
 * @param {Object} params - Query parameters (countryid, schoolid, active)
 * @returns Promise with array of screening window statuses
 */
export function getScreeningWindowStatuses(params = {}) {
  return instance
    .get("/screening-window-status", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get screening window status by ID
 *
 * @param {string} id - Screening window status ID
 * @returns Promise with screening window status
 */
export function getScreeningWindowStatusById(id) {
  return instance
    .get(`/screening-window-status/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Upsert screening window status
 *
 * @param {Object} data - Screening window status data
 * @returns Promise with upserted screening window status
 */
export function upsertScreeningWindowStatus(data) {
  return instance
    .put("/screening-window-status/upsert", data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update screening window status by ID
 *
 * @param {string} id - Screening window status ID
 * @param {Object} data - Partial screening window status data
 * @returns Promise
 */
export function updateScreeningWindowStatus(id, data) {
  return instance
    .patch(`/screening-window-status/${id}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Toggle active status of screening window
 *
 * @param {string} id - Screening window status ID
 * @param {string} updatedBy - User ID making the change
 * @returns Promise with updated screening window status
 */
export function toggleScreeningWindowActive(id, updatedBy) {
  return instance
    .patch(`/screening-window-status/${id}/toggle-active`, null, {
      params: { updated_by: updatedBy },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete screening window status by ID
 *
 * @param {string} id - Screening window status ID
 * @returns Promise
 */
export function deleteScreeningWindowStatus(id) {
  return instance
    .delete(`/screening-window-status/${id}`)
    .then((response) => {
      return response.data;
    });
}

// =====================================================
// PILOT ENDPOINTS
// =====================================================

/**
 * Create new pilot (single school)
 *
 * @param {Object} data - Pilot data
 * @returns Promise with created pilot
 */
export function createPilot(data) {
  return instance
    .post("/pilots", data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create multiple pilots (bulk)
 *
 * @param {Object} data - Bulk pilot data (schoolids array + common fields)
 * @returns Promise with {created: [], duplicates: []}
 */
export function createPilotsBulk(data) {
  return instance
    .post("/pilots/bulk", data)
    .then((response) => {
      console.log('Bulk pilot creation response:', response.data);
      return response.data;
    });
}

/**
 * Get pilots by filters
 *
 * @param {Object} params - Query parameters (schoolid, countryid, active, academic_year)
 * @returns Promise with array of pilots
 */
export function getPilots(params = {}) {
  return instance
    .get("/pilots", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get pilot by ID
 *
 * @param {string} id - Pilot ID
 * @returns Promise with pilot
 */
export function getPilotById(id) {
  return instance
    .get(`/pilots/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get pilot by ID
 *
 * @param {string} id - Pilot ID
 * @returns Promise with pilot
 */
export function getPilotBySchoolId(schoolid) {
  return instance
    .get(`/pilots/${schoolid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update pilot by ID
 *
 * @param {string} id - Pilot ID
 * @param {Object} data - Partial pilot data
 * @returns Promise with updated pilot
 */
export function updatePilot(id, data) {
  return instance
    .patch(`/pilots/${id}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete pilot by ID
 *
 * @param {string} id - Pilot ID
 * @returns Promise
 */
export function deletePilot(id) {
  return instance
    .delete(`/pilots/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get pilot count by filters
 *
 * @param {Object} params - Query parameters (schoolid, countryid, active)
 * @returns Promise with count object
 */
export function getPilotCount(params = {}) {
  return instance
    .get("/pilots/count", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new school
 * @param {Object} schoolData - School data including name, countryid, rollnumber, area (optional), crmid (optional)
 * @returns Promise with created school
 */
export function createSchool(schoolData) {
  return instance
    .post("/schools", schoolData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create multiple schools in batch
 * @param {Array} schoolsArray - Array of school objects
 * @returns Promise with array of created schools
 */
export function createSchoolsBatch(schoolsArray) {
  return Promise.all(
    schoolsArray.map(school => createSchool(school))
  );
}

// ============================================
// COMMUNICATION RULES
// ============================================

/**
 * Get all communication rules
 * @param {Object} filter - Optional filter parameters
 * @returns {Promise} Array of communication rules
 */
export function getCommunicationRules(filter = {}) {
  return instance
    .get("/communication-rules", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get only active communication rules
 * @returns {Promise} Array of active communication rules
 */
export function getActiveCommunicationRules() {
  return instance
    .get("/communication-rules/active")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific communication rule by ID
 * @param {string} ruleId
 * @returns {Promise} Communication rule object
 */
export function getCommunicationRuleById(ruleId) {
  return instance
    .get(`/communication-rules/${ruleId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all rules for a specific assessment
 * @param {string} assessmentId
 * @returns {Promise} Array of communication rules
 */
export function getCommunicationRulesByAssessment(assessmentId) {
  return instance
    .get(`/communication-rules/by-assessment/${assessmentId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new communication rule
 * @param {Object} ruleData
 * @returns {Promise} Created communication rule
 */
export function createCommunicationRule(ruleData) {
  return instance
    .post("/communication-rules", ruleData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update a communication rule
 * @param {string} ruleId
 * @param {Object} updates
 * @returns {Promise}
 */
export function updateCommunicationRule(ruleId, updates) {
  return instance
    .patch(`/communication-rules/${ruleId}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete a communication rule
 * @param {string} ruleId
 * @returns {Promise}
 */
export function deleteCommunicationRule(ruleId) {
  return instance
    .delete(`/communication-rules/${ruleId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Toggle active status of a rule
 * @param {string} ruleId
 * @returns {Promise} Updated status object
 */
export function toggleCommunicationRuleActive(ruleId) {
  return instance
    .patch(`/communication-rules/${ruleId}/toggle-active`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Bulk update multiple rules
 * @param {Array} ruleIds - Array of rule IDs
 * @param {Object} updates - Updates to apply
 * @returns {Promise} Count of updated rules
 */
export function bulkUpdateCommunicationRules(ruleIds, updates) {
  return instance
    .patch("/communication-rules/bulk-update", { ids: ruleIds, updates })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of communication rules
 * @param {Object} where - Optional where clause
 * @returns {Promise} Count object
 */
export function getCommunicationRulesCount(where = {}) {
  return instance
    .get("/communication-rules/count", { params: { where } })
    .then((response) => {
      return response.data;
    });
}

// ============================================
// EMAIL TEMPLATES
// ============================================

/**
 * Get all email templates
 * @param {Object} filter - Optional filter parameters
 * @returns {Promise} Array of email templates
 */
export function getEmailTemplates(filter = {}) {
  return instance
    .get("/message-templates/email", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific email template by ID
 * @param {string} templateId
 * @returns {Promise} Email template object
 */
export function getEmailTemplateById(templateId) {
  return instance
    .get(`/message-templates/email/${templateId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new email template
 * @param {Object} templateData
 * @returns {Promise} Created email template
 */
export function createEmailTemplate(templateData) {
  return instance
    .post("/message-templates/email", templateData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update an email template
 * @param {string} templateId
 * @param {Object} updates
 * @returns {Promise}
 */
export function updateEmailTemplate(templateId, updates) {
  return instance
    .patch(`/message-templates/email/${templateId}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete an email template
 * @param {string} templateId
 * @returns {Promise}
 */
export function deleteEmailTemplate(templateId) {
  return instance
    .delete(`/message-templates/email/${templateId}`)
    .then((response) => {
      return response.data;
    });
}

// ============================================
// IN-PLATFORM MESSAGE TEMPLATES
// ============================================

/**
 * Get all in-platform message templates
 * @param {Object} filter - Optional filter parameters
 * @returns {Promise} Array of in-platform templates
 */
export function getInPlatformTemplates(filter = {}) {
  return instance
    .get("/message-templates/in-platform", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific in-platform template by ID
 * @param {string} templateId
 * @returns {Promise} In-platform template object
 */
export function getInPlatformTemplateById(templateId) {
  return instance
    .get(`/message-templates/in-platform/${templateId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new in-platform message template
 * @param {Object} templateData
 * @returns {Promise} Created in-platform template
 */
export function createInPlatformTemplate(templateData) {
  return instance
    .post("/message-templates/in-platform", templateData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update an in-platform message template
 * @param {string} templateId
 * @param {Object} updates
 * @returns {Promise}
 */
export function updateInPlatformTemplate(templateId, updates) {
  return instance
    .patch(`/message-templates/in-platform/${templateId}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete an in-platform message template
 * @param {string} templateId
 * @returns {Promise}
 */
export function deleteInPlatformTemplate(templateId) {
  return instance
    .delete(`/message-templates/in-platform/${templateId}`)
    .then((response) => {
      return response.data;
    });
}

// ============================================
// UNIFIED TEMPLATE OPERATIONS
// ============================================

/**
 * Get both email and in-platform templates for a rule
 * @param {string} ruleId
 * @returns {Promise} Object with email and inPlatform templates
 */
export function getTemplatesByRule(ruleId) {
  return instance
    .get(`/message-templates/by-rule/${ruleId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create both email and in-platform templates for a rule
 * @param {string} ruleId
 * @param {Object} templatesData - Contains ruleType, email, and inPlatform objects
 * @returns {Promise} Object with created email and inPlatform templates
 */
export function createBothTemplates(ruleId, templatesData) {
  return instance
    .post(`/message-templates/by-rule/${ruleId}`, templatesData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Preview rendered templates with sample data
 * @param {Object} previewData - Contains ruleId, ruleType, and sampleData
 * @returns {Promise} Rendered email and in-platform message preview
 */
export function previewTemplates(previewData) {
  return instance
    .post("/message-templates/preview", previewData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of all templates
 * @returns {Promise} Object with email and inPlatform counts
 */
export function getTemplatesCounts() {
  return instance
    .get("/message-templates/count")
    .then((response) => {
      return response.data;
    });
}

// ============================================
// JOB RUNS
// ============================================

/**
 * Get all job runs
 * @param {Object} filter - Optional filter parameters
 * @returns {Promise} Array of job runs
 */
export function getJobRuns(filter = {}) {
  return instance
    .get("/job-runs", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific job run by ID
 * @param {string} jobRunId
 * @returns {Promise} Job run object
 */
export function getJobRunById(jobRunId) {
  return instance
    .get(`/job-runs/${jobRunId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get the most recent job run
 * @returns {Promise} Latest job run object
 */
export function getLatestJobRun() {
  return instance
    .get("/job-runs/latest")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get job runs by status
 * @param {string} status - Status to filter by (running, completed, completed_with_limit, failed)
 * @param {number} limit - Optional limit
 * @returns {Promise} Array of job runs
 */
export function getJobRunsByStatus(status, limit) {
  return instance
    .get(`/job-runs/status/${status}`, { params: { limit } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all failed job runs
 * @returns {Promise} Array of failed job runs
 */
export function getFailedJobRuns() {
  return instance
    .get("/job-runs/failed")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recent job runs
 * @param {number} hours - Number of hours to look back (default 24)
 * @returns {Promise} Array of recent job runs
 */
export function getRecentJobRuns(hours = 24) {
  return instance
    .get("/job-runs/recent", { params: { hours } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all events created during a specific job run
 * @param {string} jobRunId
 * @returns {Promise} Array of events
 */
export function getJobRunEvents(jobRunId) {
  return instance
    .get(`/job-runs/${jobRunId}/events`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get aggregated job run statistics
 * @returns {Promise} Statistics object
 */
export function getJobRunStatistics() {
  return instance
    .get("/job-runs/statistics")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get daily summary of job runs
 * @param {number} days - Number of days to look back (default 7)
 * @returns {Promise} Array of daily summaries
 */
export function getJobRunDailySummary(days = 7) {
  return instance
    .get("/job-runs/summary/daily", { params: { days } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Manually trigger a threshold check job
 * @returns {Promise} Job run result
 */
export function triggerJobRun() {
  return instance
    .post("/job-runs/trigger")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get health status of job run system
 * @returns {Promise} Health status object
 */
export function getJobRunHealth() {
  return instance
    .get("/job-runs/health")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get detailed error information for a job run
 * @param {string} jobRunId
 * @returns {Promise} Error details object
 */
export function getJobRunErrors(jobRunId) {
  return instance
    .get(`/job-runs/${jobRunId}/errors`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of job runs
 * @param {Object} where - Optional where clause
 * @returns {Promise} Count object
 */
export function getJobRunsCount(where = {}) {
  return instance
    .get("/job-runs/count", { params: { where } })
    .then((response) => {
      return response.data;
    });
}

// ============================================
// SCHOOL METRIC EVENTS
// ============================================

/**
 * Get all school metric events
 * @param {Object} filter - Optional filter parameters
 * @returns {Promise} Array of events
 */
export function getSchoolMetricEvents(filter = {}) {
  return instance
    .get("/school-metric-events", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific event by ID
 * @param {string} eventId
 * @returns {Promise} Event object
 */
export function getSchoolMetricEventById(eventId) {
  return instance
    .get(`/school-metric-events/${eventId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all events for a specific school
 * @param {string} schoolId
 * @param {string} academicYear - Optional academic year filter
 * @returns {Promise} Array of events
 */
export function getSchoolMetricEventsBySchool(schoolId, academicYear) {
  return instance
    .get(`/school-metric-events/by-school/${schoolId}`, {
      params: { academicYear },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all events for a specific rule
 * @param {string} ruleId
 * @param {string} academicYear - Optional academic year filter
 * @returns {Promise} Array of events
 */
export function getSchoolMetricEventsByRule(ruleId, academicYear) {
  return instance
    .get(`/school-metric-events/by-rule/${ruleId}`, {
      params: { academicYear },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get events for a specific academic year
 * @param {string} year - Academic year (e.g., "2024-25")
 * @returns {Promise} Array of events
 */
export function getSchoolMetricEventsByAcademicYear(year) {
  return instance
    .get(`/school-metric-events/by-academic-year/${year}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get unprocessed events
 * @returns {Promise} Array of unprocessed events
 */
export function getUnprocessedSchoolMetricEvents() {
  return instance
    .get("/school-metric-events/unprocessed")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get events with processing errors
 * @returns {Promise} Array of events with errors
 */
export function getSchoolMetricEventsWithErrors() {
  return instance
    .get("/school-metric-events/with-errors")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recent events
 * @param {number} hours - Number of hours to look back (default 24)
 * @returns {Promise} Array of recent events
 */
export function getRecentSchoolMetricEvents(hours = 24) {
  return instance
    .get("/school-metric-events/recent", { params: { hours } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all messages sent for a specific event
 * @param {string} eventId
 * @returns {Promise} Array of messages
 */
export function getSchoolMetricEventMessages(eventId) {
  return instance
    .get(`/school-metric-events/${eventId}/messages`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get aggregated event statistics
 * @returns {Promise} Statistics object
 */
export function getSchoolMetricEventStatistics() {
  return instance
    .get("/school-metric-events/statistics")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get event timeline with daily aggregation
 * @param {number} days - Number of days to look back (default 30)
 * @returns {Promise} Array of daily timeline data
 */
export function getSchoolMetricEventTimeline(days = 30) {
  return instance
    .get("/school-metric-events/timeline", { params: { days } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get dashboard summary for events
 * @returns {Promise} Dashboard summary object
 */
export function getSchoolMetricEventDashboard() {
  return instance
    .get("/school-metric-events/dashboard")
    .then((response) => {
      return response.data;
    });
}

/**
 * Retry processing a failed event
 * @param {string} eventId
 * @returns {Promise} Reprocessing result
 */
export function reprocessSchoolMetricEvent(eventId) {
  return instance
    .post(`/school-metric-events/${eventId}/reprocess`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update an event
 * @param {string} eventId
 * @param {Object} updates
 * @returns {Promise}
 */
export function updateSchoolMetricEvent(eventId, updates) {
  return instance
    .patch(`/school-metric-events/${eventId}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Export events to CSV
 * @param {string} academicYear - Optional academic year filter
 * @param {string} ruleId - Optional rule ID filter
 * @returns {Promise} CSV string
 */
export function exportSchoolMetricEventsToCSV(academicYear, ruleId) {
  return instance
    .get("/school-metric-events/export", {
      params: { academicYear, ruleId },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of events
 * @param {Object} where - Optional where clause
 * @returns {Promise} Count object
 */
export function getSchoolMetricEventsCount(where = {}) {
  return instance
    .get("/school-metric-events/count", { params: { where } })
    .then((response) => {
      return response.data;
    });
}


/**
 * Get trial conversion metrics
 * @param {string} countryId - Country identifier
 * @param {string} trialStartDate - Start date for trial period
 * @param {string} screeningStartDate - Start date for screening period
 * @param {string} grade1AssessmentId - Assessment ID for grade level 1
 * @param {string} doeEnrollmentYear - Department of Education enrollment year
 * @returns Trial conversion metrics data
 */
export function getTrialConversionMetrics(
  countryId,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  doeEnrollmentYear,
  academicYear
) {
  return instance
    .get("/trial-screening/conversion-metrics", {
      params: {
        countryId,
        trialStartDate,
        screeningStartDate,
        grade1AssessmentId,
        doeEnrollmentYear,
        academicYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get schools with 0-24% screening completion
 * @param {string} countryId - Country identifier
 * @param {string} academicYear - Academic year
 * @param {string} trialStartDate - Start date for trial period
 * @param {string} screeningStartDate - Start date for screening period
 * @param {string} grade1AssessmentId - Assessment ID for grade level 1
 * @param {string} grade2AssessmentId - Assessment ID for grade level 2
 * @param {string} doeEnrollmentYear - Department of Education enrollment year
 * @returns Schools in 0-24% screening completion range
 */
export function getColdTrials(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance
    .get("/trial-screening/under-25", {
      params: {
        countryId,
        academicYear,
        trialStartDate,
        screeningStartDate,
        grade1AssessmentId,
        grade2AssessmentId,
        doeEnrollmentYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get schools with 25-49% screening completion
 * @param {string} countryId - Country identifier
 * @param {string} academicYear - Academic year
 * @param {string} trialStartDate - Start date for trial period
 * @param {string} screeningStartDate - Start date for screening period
 * @param {string} grade1AssessmentId - Assessment ID for grade level 1
 * @param {string} grade2AssessmentId - Assessment ID for grade level 2
 * @param {string} doeEnrollmentYear - Department of Education enrollment year
 * @returns Schools in 25-49% screening completion range
 */
export function getCoolTrials(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance
    .get("/trial-screening/25-to-50", {
      params: {
        countryId,
        academicYear,
        trialStartDate,
        screeningStartDate,
        grade1AssessmentId,
        grade2AssessmentId,
        doeEnrollmentYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get schools with 50-74% screening completion
 * @param {string} countryId - Country identifier
 * @param {string} academicYear - Academic year
 * @param {string} trialStartDate - Start date for trial period
 * @param {string} screeningStartDate - Start date for screening period
 * @param {string} grade1AssessmentId - Assessment ID for grade level 1
 * @param {string} grade2AssessmentId - Assessment ID for grade level 2
 * @param {string} doeEnrollmentYear - Department of Education enrollment year
 * @returns Schools in 50-74% screening completion range
 */
export function getWarmTrials(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance
    .get("/trial-screening/50-to-75", {
      params: {
        countryId,
        academicYear,
        trialStartDate,
        screeningStartDate,
        grade1AssessmentId,
        grade2AssessmentId,
        doeEnrollmentYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get schools with 75-100% screening completion
 * @param {string} countryId - Country identifier
 * @param {string} academicYear - Academic year
 * @param {string} trialStartDate - Start date for trial period
 * @param {string} screeningStartDate - Start date for screening period
 * @param {string} grade1AssessmentId - Assessment ID for grade level 1
 * @param {string} grade2AssessmentId - Assessment ID for grade level 2
 * @param {string} doeEnrollmentYear - Department of Education enrollment year
 * @returns Schools in 75-100% screening completion range
 */
export function getHotTrials(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance
    .get("/trial-screening/75-to-100", {
      params: {
        countryId,
        academicYear,
        trialStartDate,
        screeningStartDate,
        grade1AssessmentId,
        grade2AssessmentId,
        doeEnrollmentYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get overall trial health data
 * @param {string} countryId - Country identifier
 * @param {string} academicYear - Academic year
 * @returns Trial health data
 */
export function getTrialHealthData(
  countryId,
  academicYear
) {
  return instance
    .get("/trial-health-data", {
      params: {
        countryId,
        academicYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get schools with no Department of Education match
 * @param {string} countryId - Country identifier
 * @param {string} academicYear - Academic year
 * @param {string} trialStartDate - Start date for trial period
 * @param {string} doeEnrollmentYear - Department of Education enrollment year
 * @returns Schools without DOE enrollment data matches
 */
export function getNoDoeMatchTrials(
  countryId,
  academicYear,
  trialStartDate,
  doeEnrollmentYear
) {
  return instance
    .get("/trial-screening/no-doe-match", {
      params: {
        countryId,
        academicYear,
        trialStartDate,
        doeEnrollmentYear
      }
    })
    .then((response) => {
      return response;
    });
}

/**
 * Get Department of Education student screening coverage metrics
 */
export function getDeptEdStudentMetrics(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance.get("/trial-screening/doe-screening-coverage", {
    params: {
      countryId,
      academicYear,
      trialStartDate,
      screeningStartDate,
      grade1AssessmentId,
      grade2AssessmentId,
      doeEnrollmentYear
    }
  });
  // Note: No .then() - returns full axios response like other functions
}

/**
 * Get list of schools in Hot trials category (75-100%)
 */
export function getHotTrialSchools(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance.get("/trial-screening/school-list-75-to-100", {
    params: {
      countryId,
      academicYear,
      trialStartDate,
      screeningStartDate,
      grade1AssessmentId,
      grade2AssessmentId,
      doeEnrollmentYear
    }
  });
}

/**
 * Get list of schools in Warm trials category (50-75%)
 */
export function getWarmTrialSchools(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance.get("/trial-screening/school-list-50-to-75", {
    params: {
      countryId,
      academicYear,
      trialStartDate,
      screeningStartDate,
      grade1AssessmentId,
      grade2AssessmentId,
      doeEnrollmentYear
    }
  });
}

/**
 * Get list of schools in Cool trials category (25-50%)
 */
export function getCoolTrialSchools(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance.get("/trial-screening/school-list-25-to-50", {
    params: {
      countryId,
      academicYear,
      trialStartDate,
      screeningStartDate,
      grade1AssessmentId,
      grade2AssessmentId,
      doeEnrollmentYear
    }
  });
}

/**
 * Get list of schools in Cold trials category (0-25%)
 */
export function getColdTrialSchools(
  countryId,
  academicYear,
  trialStartDate,
  screeningStartDate,
  grade1AssessmentId,
  grade2AssessmentId,
  doeEnrollmentYear
) {
  return instance.get("/trial-screening/school-list-under-25", {
    params: {
      countryId,
      academicYear,
      trialStartDate,
      screeningStartDate,
      grade1AssessmentId,
      grade2AssessmentId,
      doeEnrollmentYear
    }
  });
}

/**
 * Trigger threshold check for all schools
 *
 * @returns Promise with threshold check results
 */
export function triggerThresholdCheck() {
  return instance
    .post('/test/trigger-threshold-check')
    .then((response) => {
      return response.data;
    });
}

/**
 * Trigger threshold check for a specific school
 *
 * @param {string} schoolId - The ID of the school to check
 * @param {string} [ruleId] - Optional ID of specific rule to test
 * @returns Promise with threshold check results for the school
 */
export function triggerThresholdCheckForSchool(schoolId, ruleId) {
  const params = {};

  if (ruleId) {
    params.ruleId = ruleId;
  }

  return instance
    .post(`/test/trigger-threshold-check-for-school/${schoolId}`, null, {
      params: params,
    })
    .then((response) => {
      return response.data;
    });
}


// ==================== CLASS DELETED ENDPOINTS ====================

/**
 * Get deleted classes for a specific school
 *
 * @param {string} schoolid - School ID
 * @param {boolean} includeRestored - Whether to include already restored classes
 * @param {number} limit - Max number of results
 * @param {number} skip - Number of results to skip
 * @returns Promise with {data: ClassDeleted[], total: number}
 */
export function getDeletedClassesBySchool(schoolid, includeRestored = false, limit = 100, skip = 0) {
  return instance
    .get(`/deleted/classes/school/${schoolid}`, {
      params: { includeRestored, limit, skip }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a single deleted class by ID
 *
 * @param {string} id - Deleted class ID
 * @returns Promise with ClassDeleted object
 */
export function getDeletedClassById(id) {
  return instance
    .get(`/deleted/classes/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Restore a deleted class
 *
 * @param {string} id - Deleted class ID
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredClassId: string, message: string}
 */
export function restoreClass(id, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/deleted/classes/${id}/restore`, {
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Batch restore deleted classes for a school
 *
 * @param {string} schoolid - School ID
 * @param {string[]} deletedClassIds - Array of deleted class IDs
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredCount: number, restoredClassIds: string[], errors: Array}
 */
export function batchRestoreClasses(schoolid, deletedClassIds, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/deleted/classes/school/${schoolid}/batch-restore`, {
      deletedClassIds,
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

// ==================== STUDENT DELETED ENDPOINTS ====================

/**
 * Get deleted students for a specific school
 *
 * @param {string} schoolid - School ID
 * @param {boolean} includeRestored - Whether to include already restored students
 * @param {number} limit - Max number of results
 * @param {number} skip - Number of results to skip
 * @returns Promise with {data: StudentDeleted[], total: number}
 */
export function getDeletedStudentsBySchool(schoolid, includeRestored = false, limit = 100, skip = 0) {
  return instance
    .get(`/deleted/students/school/${schoolid}`, {
      params: { includeRestored, limit, skip }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a single deleted student by ID
 *
 * @param {string} id - Deleted student ID
 * @returns Promise with StudentDeleted object
 */
export function getDeletedStudentById(id) {
  return instance
    .get(`/deleted/students/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Restore a deleted student
 *
 * @param {string} id - Deleted student ID
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredStudentId: string, message: string}
 */
export function restoreStudent(id, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/deleted/students/${id}/restore`, {
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Batch restore deleted students for a school
 *
 * @param {string} schoolid - School ID
 * @param {string[]} deletedStudentIds - Array of deleted student IDs
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredCount: number, restoredStudentIds: string[], errors: Array}
 */
export function batchRestoreStudents(schoolid, deletedStudentIds, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/deleted/students/school/${schoolid}/batch-restore`, {
      deletedStudentIds,
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

// ==================== TEACHER DELETED ENDPOINTS ====================

/**
 * Get deleted teachers for a specific school
 *
 * @param {string} schoolid - School ID
 * @param {boolean} includeRestored - Whether to include already restored teachers
 * @param {number} limit - Max number of results
 * @param {number} skip - Number of results to skip
 * @returns Promise with {data: TeacherDeleted[], total: number}
 */
export function getDeletedTeachersBySchool(schoolid, includeRestored = false, limit = 100, skip = 0) {
  return instance
    .get(`/deleted/teachers/school/${schoolid}`, {
      params: { includeRestored, limit, skip }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a single deleted teacher by ID
 *
 * @param {string} id - Deleted teacher ID
 * @returns Promise with TeacherDeleted object
 */
export function getDeletedTeacherById(id) {
  return instance
    .get(`/deleted/teachers/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Restore a deleted teacher
 *
 * @param {string} id - Deleted teacher ID
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredTeacherId: string, message: string}
 */
export function restoreTeacher(id, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/deleted/teachers/${id}/restore`, {
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Batch restore deleted teachers for a school
 *
 * @param {string} schoolid - School ID
 * @param {string[]} deletedTeacherIds - Array of deleted teacher IDs
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredCount: number, restoredTeacherIds: string[], errors: Array}
 */
export function batchRestoreTeachers(schoolid, deletedTeacherIds, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/deleted/teachers/school/${schoolid}/batch-restore`, {
      deletedTeacherIds,
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

// ==================== ARCHIVED ASSESSMENT INSTANCE ENDPOINTS ====================

/**
 * Get archived assessment instances for a specific school
 *
 * @param {string} schoolid - School ID
 * @param {boolean} includeRestored - Whether to include already restored assessments
 * @param {string} studentid - Optional: filter by student ID
 * @param {string} academicYear - Optional: filter by academic year
 * @param {number} limit - Max number of results
 * @param {number} skip - Number of results to skip
 * @returns Promise with {data: ArchivedAssessmentInstance[], total: number}
 */
export function getArchivedAssessmentsBySchool(schoolid, includeRestored = false, studentid = null, academicYear = null, limit = 100, skip = 0) {
  const params = { includeRestored, limit, skip };
  if (studentid) params.studentid = studentid;
  if (academicYear) params.academicYear = academicYear;

  return instance
    .get(`/archived-assessment-instances/school/${schoolid}`, { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get archived assessment instances for a specific student
 *
 * @param {string} studentId - Student ID
 * @param {string} academicYear - Optional: filter by academic year
 * @returns Promise with array of archived assessments
 */
export function getArchivedAssessmentsByStudent(studentId, academicYear = null) {
  const params = {};
  if (academicYear) params.academicYear = academicYear;

  return instance
    .get(`/archived-assessment-instances/student/${studentId}`, { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Restore an archived assessment instance
 *
 * @param {string} id - Archived assessment instance ID
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredAssessmentInstanceId: string, message: string}
 */
export function restoreArchivedAssessment(id, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/archived-assessment-instances/${id}/restore`, {
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Batch restore archived assessment instances
 *
 * @param {string[]} archivedAssessmentIds - Array of archived assessment IDs
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredCount: number, restoredAssessmentInstanceIds: string[], errors: Array}
 */
export function batchRestoreArchivedAssessments(archivedAssessmentIds, restoredByTeacherId, restoredByTeacherName) {
  return instance
    .post(`/archived-assessment-instances/batch-restore`, {
      archivedAssessmentIds,
      restoredByTeacherId,
      restoredByTeacherName
    })
    .then((response) => {
      return response.data;
    });
}

// ==================== ANSWER DELETED ENDPOINTS ====================

/**
 * Get deleted answers for a specific school
 *
 * @param {string} schoolid - School ID
 * @param {boolean} includeRestored - Whether to include already restored answers
 * @param {string} studentid - Optional: filter by student ID
 * @param {number} limit - Max number of results
 * @param {number} skip - Number of results to skip
 * @returns Promise with {data: AnswerDeletedLog[], total: number}
 */
export function getDeletedAnswersBySchool(schoolid, includeRestored = false, studentid = null, limit = 100, skip = 0) {
  const params = { includeRestored, limit, skip };
  if (studentid) params.studentid = studentid;

  return instance
    .get(`/deleted/answers/school/${schoolid}`, { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get deleted answers for a specific student
 *
 * @param {string} studentid - Student ID
 * @param {boolean} includeRestored - Whether to include already restored answers
 * @param {number} limit - Max number of results
 * @param {number} skip - Number of results to skip
 * @returns Promise with {data: AnswerDeletedLog[], total: number}
 */
export function getDeletedAnswersByStudent(studentid, includeRestored = false, limit = 100, skip = 0) {
  return instance
    .get(`/deleted/answers/student/${studentid}`, {
      params: { includeRestored, limit, skip }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a single deleted answer by ID
 *
 * @param {string} id - Deleted answer ID
 * @returns Promise with AnswerDeletedLog object
 */
export function getDeletedAnswerById(id) {
  return instance
    .get(`/deleted/answers/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get deleted answers for a specific assessment instance
 *
 * @param {string} assessmentInstanceId - Assessment instance ID
 * @returns Promise with array of deleted answers
 */
export function getDeletedAnswersByAssessmentInstance(assessmentInstanceId) {
  return instance
    .get(`/assessment-instances/${assessmentInstanceId}/deleted-answers`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get both active and deleted answers for an assessment instance
 *
 * @param {string} assessmentInstanceId - Assessment instance ID
 * @returns Promise with {activeAnswers: Array, deletedAnswers: Array}
 */
export function getAllAnswersByAssessmentInstance(assessmentInstanceId) {
  return instance
    .get(`/assessment-instances/${assessmentInstanceId}/all-answers`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Restore a deleted answer
 *
 * @param {string} id - Deleted answer ID
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredAnswerId: string, message: string}
 */
export function restoreAnswer(id) {
  return instance
    .post(`/deleted/answers/${id}/restore`, {})
    .then((response) => {
      return response.data;
    });
}

/**
 * Batch restore deleted answers for a school
 *
 * @param {string} schoolid - School ID
 * @param {string[]} deletedAnswerIds - Array of deleted answer IDs
 * @param {string} restoredByTeacherId - ID of teacher performing restoration
 * @param {string} restoredByTeacherName - Name of teacher performing restoration
 * @returns Promise with {restoredCount: number, restoredAnswerIds: string[], errors: Array}
 */
export function batchRestoreAnswers(schoolid, deletedAnswerIds) {
  return instance
    .post(`/deleted/answers/school/${schoolid}/batch-restore`, {
      deletedAnswerIds
    })
    .then((response) => {
      return response.data;
    });
}

// ==================== CONTENT RETRIEVAL (Main Frontend Usage) ====================

/**
 * Get formatted content for sandbox or modal based on country, context, grade level
 *
 * @param {string} countryid - Country ID
 * @param {string} context - 'sandbox' or 'modal'
 * @param {string} gradelevel - Optional grade level
 * @param {string} schoolid - Optional school ID for access rules
 * @returns Array of formatted content folders with cards
 */
export function getContent(countryid, context, gradelevel = null, schoolid = null) {
  const params = new URLSearchParams({
    countryid,
    context,
  });

  if (gradelevel) params.append('gradelevel', gradelevel);
  if (schoolid) params.append('schoolid', schoolid);

  return instance
    .get(`/content?${params.toString()}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get modal-specific content formatted for the video modal
 *
 * @param {string} countryid - Country ID
 * @param {string} schoolid - Optional school ID
 * @returns Object with buttonText, modalTitle, modalParagraph, and videos array
 */
export function getModalContent(countryid, schoolid = null) {
  const params = new URLSearchParams({ countryid });

  if (schoolid) params.append('schoolid', schoolid);

  return instance
    .get(`/content/modal?${params.toString()}`)
    .then((response) => {
      return response.data;
    });
}

// ==================== CONTENT ITEMS ====================

/**
 * Create a new content item
 *
 * @param {object} contentItem - Content item data
 * @returns Created content item
 */
export function createContentItem(contentItem) {
  return instance
    .post("/content-items", contentItem)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all content items with optional filters
 *
 * @param {object} filter - LoopBack filter object
 * @returns Array of content items
 */
export function getContentItems(filter = {}) {
  return instance
    .get("/content-items", { params: { filter: JSON.stringify(filter) } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get content item by ID
 *
 * @param {string} id - Content item ID
 * @returns Content item
 */
export function getContentItemById(id) {
  return instance
    .get(`/content-items/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update content item by ID
 *
 * @param {string} id - Content item ID
 * @param {object} updates - Fields to update
 * @returns Updated content item
 */
export function updateContentItem(id, updates) {
  return instance
    .patch(`/content-items/${id}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete content item by ID
 *
 * @param {string} id - Content item ID
 * @returns Deletion confirmation
 */
export function deleteContentItem(id) {
  return instance
    .delete(`/content-items/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate content item
 *
 * @param {string} id - Content item ID
 * @returns Activation confirmation
 */
export function activateContentItem(id) {
  return instance
    .patch(`/content-items/${id}/activate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate content item
 *
 * @param {string} id - Content item ID
 * @returns Deactivation confirmation
 */
export function deactivateContentItem(id) {
  return instance
    .patch(`/content-items/${id}/deactivate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of content items
 *
 * @param {object} where - Where clause
 * @returns Count object
 */
export function countContentItems(where = {}) {
  return instance
    .get("/content-items/count", { params: { where: JSON.stringify(where) } })
    .then((response) => {
      return response.data;
    });
}

// ==================== CONTENT CATEGORIES ====================

/**
 * Create a new content category
 *
 * @param {object} category - Category data
 * @returns Created category
 */
export function createContentCategory(category) {
  return instance
    .post("/content-categories", category)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all content categories with optional filters
 *
 * @param {object} filter - LoopBack filter object
 * @returns Array of categories
 */
export function getContentCategories(filter = {}) {
  return instance
    .get("/content-categories", { params: { filter: JSON.stringify(filter) } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get content category by ID
 *
 * @param {string} id - Category ID
 * @returns Category
 */
export function getContentCategoryById(id) {
  return instance
    .get(`/content-categories/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update content category by ID
 *
 * @param {string} id - Category ID
 * @param {object} updates - Fields to update
 * @returns Updated category
 */
export function updateContentCategory(id, updates) {
  return instance
    .patch(`/content-categories/${id}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete content category by ID
 *
 * @param {string} id - Category ID
 * @returns Deletion confirmation
 */
export function deleteContentCategory(id) {
  return instance
    .delete(`/content-categories/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate content category
 *
 * @param {string} id - Category ID
 * @returns Activation confirmation
 */
export function activateContentCategory(id) {
  return instance
    .patch(`/content-categories/${id}/activate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate content category
 *
 * @param {string} id - Category ID
 * @returns Deactivation confirmation
 */
export function deactivateContentCategory(id) {
  return instance
    .patch(`/content-categories/${id}/deactivate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of content categories
 *
 * @param {object} where - Where clause
 * @returns Count object
 */
export function countContentCategories(where = {}) {
  return instance
    .get("/content-categories/count", { params: { where: JSON.stringify(where) } })
    .then((response) => {
      return response.data;
    });
}

// ==================== REGIONAL CONTENT ====================

/**
 * Create a new regional content mapping
 *
 * @param {object} regionalContent - Regional content data
 * @returns Created regional content
 */
export function createRegionalContent(regionalContent) {
  return instance
    .post("/regional-content", regionalContent)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all regional content with optional filters
 *
 * @param {object} filter - LoopBack filter object
 * @returns Array of regional content
 */
export function getRegionalContent(filter = {}) {
  return instance
    .get("/regional-content", { params: { filter: JSON.stringify(filter) } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get regional content by ID
 *
 * @param {string} id - Regional content ID
 * @returns Regional content
 */
export function getRegionalContentById(id) {
  return instance
    .get(`/regional-content/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update regional content by ID
 *
 * @param {string} id - Regional content ID
 * @param {object} updates - Fields to update
 * @returns Updated regional content
 */
export function updateRegionalContent(id, updates) {
  return instance
    .patch(`/regional-content/${id}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete regional content by ID
 *
 * @param {string} id - Regional content ID
 * @returns Deletion confirmation
 */
export function deleteRegionalContent(id) {
  return instance
    .delete(`/regional-content/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate regional content
 *
 * @param {string} id - Regional content ID
 * @returns Activation confirmation
 */
export function activateRegionalContent(id) {
  return instance
    .patch(`/regional-content/${id}/activate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate regional content
 *
 * @param {string} id - Regional content ID
 * @returns Deactivation confirmation
 */
export function deactivateRegionalContent(id) {
  return instance
    .patch(`/regional-content/${id}/deactivate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of regional content
 *
 * @param {object} where - Where clause
 * @returns Count object
 */
export function countRegionalContent(where = {}) {
  return instance
    .get("/regional-content/count", { params: { where: JSON.stringify(where) } })
    .then((response) => {
      return response.data;
    });
}

// ==================== CONTENT ACCESS RULES ====================

/**
 * Create a new content access rule
 *
 * @param {object} accessRule - Access rule data
 * @returns Created access rule
 */
export function createContentAccessRule(accessRule) {
  return instance
    .post("/content-access-rules", accessRule)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all content access rules with optional filters
 *
 * @param {object} filter - LoopBack filter object
 * @returns Array of access rules
 */
export function getContentAccessRules(filter = {}) {
  return instance
    .get("/content-access-rules", { params: { filter: JSON.stringify(filter) } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get content access rule by ID
 *
 * @param {string} id - Access rule ID
 * @returns Access rule
 */
export function getContentAccessRuleById(id) {
  return instance
    .get(`/content-access-rules/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update content access rule by ID
 *
 * @param {string} id - Access rule ID
 * @param {object} updates - Fields to update
 * @returns Updated access rule
 */
export function updateContentAccessRule(id, updates) {
  return instance
    .patch(`/content-access-rules/${id}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete content access rule by ID
 *
 * @param {string} id - Access rule ID
 * @returns Deletion confirmation
 */
export function deleteContentAccessRule(id) {
  return instance
    .delete(`/content-access-rules/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate content access rule
 *
 * @param {string} id - Access rule ID
 * @returns Activation confirmation
 */
export function activateContentAccessRule(id) {
  return instance
    .patch(`/content-access-rules/${id}/activate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate content access rule
 *
 * @param {string} id - Access rule ID
 * @returns Deactivation confirmation
 */
export function deactivateContentAccessRule(id) {
  return instance
    .patch(`/content-access-rules/${id}/deactivate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of content access rules
 *
 * @param {object} where - Where clause
 * @returns Count object
 */
export function countContentAccessRules(where = {}) {
  return instance
    .get("/content-access-rules/count", { params: { where: JSON.stringify(where) } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all banner content for a specific banner type
 *
 * @param {string} bannerType - The banner type (e.g., 'freeTrialBanner')
 * @param {string} locale - Optional locale (e.g., 'en-IE')
 * @returns Promise with array of banner content
 */
export function getBannerContentByType(bannerType, locale = 'en-IE') {
  return instance
    .get(`/banner-contents/by-type/${bannerType}`, {
      params: { locale }
    })
    .then((response) => {
      return response.data;
    });
}

// /**
//  * Get all banner content with optional filters
//  *
//  * @param {object} filter - LoopBack filter object
//  * @returns Promise with array of banner content
//  */
// export function getAllBannerContent(filter = {}) {
//   return instance
//     .get('/banner-contents', {
//       params: { filter: JSON.stringify(filter) }
//     })
//     .then((response) => {
//       return response.data;
//     });
// }

/**
 * Get banner content by ID
 *
 * @param {string} id - Banner content ID
 * @returns Promise with banner content object
 */
export function getBannerContentById(id) {
  return instance
    .get(`/banner-contents/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create new banner content
 *
 * @param {object} bannerContent - Banner content object
 * @returns Promise with created banner content
 */
export function createBannerContent(bannerContent) {
  return instance
    .post('/banner-contents', bannerContent)
    .then((response) => {
      return response.data;
    });
}

// /**
//  * Update banner content by ID
//  *
//  * @param {string} id - Banner content ID
//  * @param {object} bannerContent - Updated banner content object
//  * @returns Promise
//  */
// // export function updateBannerContent(id, bannerContent) {
// //   console.log("🔄 updateBannerContent - ID:", id);
// //   console.log("📦 updateBannerContent - Payload:", bannerContent);
// //   console.log("📦 Payload Keys:", Object.keys(bannerContent));
// //   console.log("📦 Payload Values:", Object.entries(bannerContent).map(([key, value]) => ({
// //     key,
// //     value,
// //     type: typeof value,
// //     isNull: value === null,
// //     isUndefined: value === undefined,
// //   })));

// //   return instance
// //     .patch(`/banner-contents/${id}`, bannerContent)
// //     .then((response) => {
// //       console.log("✅ Update successful");
// //       return response.data;
// //     })
// //     .catch((error) => {
// //       console.error("❌ Update failed - Details:", error.response?.data?.details);
// //       throw error;
// //     });
// // }

/**
 * Delete banner content by ID
 *
 * @param {string} id - Banner content ID
 * @returns Promise
 */
export function deleteBannerContent(id) {
  return instance
    .delete(`/banner-contents/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of banner content with optional filters
 *
 * @param {object} where - LoopBack where filter
 * @returns Promise with count object
 */
export function getBannerContentCount(where = {}) {
  return instance
    .get('/banner-contents/count', {
      params: { where: JSON.stringify(where) }
    })
    .then((response) => {
      return response.data;
    });
}


// ============================================
// ADMIN APIS - Sandbox Content Management
// ============================================

/**
 * Get all sandbox content items with optional filters
 * @param {object} filter - Optional LoopBack filter object
 * @returns Array of sandbox content items
 */
export function getSandboxContent(filter) {
  return instance
    .get("/sandbox-content", { params: { filter: filter } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of sandbox content items
 * @param {object} where - Optional where filter
 * @returns Count object
 */
export function getSandboxContentCount(where) {
  return instance
    .get("/sandbox-content/count", { params: { where: where } })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get single sandbox content item by ID
 * @param {string} id - Content item ID
 * @returns Sandbox content item
 */
export function getSandboxContentById(id) {
  return instance
    .get(`/sandbox-content/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create new sandbox content item
 * @param {object} data - Content item data
 * @returns Created sandbox content item
 */
export function createSandboxContent(data) {
  return instance
    .post("/sandbox-content", data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update sandbox content item
 * @param {string} id - Content item ID
 * @param {object} data - Updated content data
 * @returns void
 */
export function updateSandboxContent(id, data) {
  return instance
    .patch(`/sandbox-content/${id}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete sandbox content item
 * @param {string} id - Content item ID
 * @returns void
 */
export function deleteSandboxContent(id) {
  return instance
    .delete(`/sandbox-content/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate sandbox content item
 * @param {string} id - Content item ID
 * @returns void
 */
export function activateSandboxContent(id) {
  return instance
    .patch(`/sandbox-content/${id}/activate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate sandbox content item
 * @param {string} id - Content item ID
 * @returns void
 */
export function deactivateSandboxContent(id) {
  return instance
    .patch(`/sandbox-content/${id}/deactivate`)
    .then((response) => {
      return response.data;
    });
}

// ============================================
// CLIENT/PUBLIC APIS - For End Users
// ============================================

/**
 * Get public sandbox content for a country (grouped by folder)
 * @param {string} countryid - Country ID
 * @returns Array of folders with cards
 */
export function getPublicSandboxContent(countryid) {
  return instance
    .get("/sandbox-content/public", {
      params: {
        countryid: countryid,
        context: "sandbox",
      },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get public modal content for a country (grouped by folder)
 * @param {string} countryid - Country ID
 * @returns Array of folders with cards
 */
export function getPublicModalContent(countryid) {
  return instance
    .get("/sandbox-content/public", {
      params: {
        countryid: countryid,
        context: "modal",
      },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Fetches an AladdinExportActivation instance by its ID.
 * Corresponds to the findById method in the controller.
 *
 * @param {string} id The ID of the AladdinExportActivation to retrieve.
 * @returns {Promise<AladdinExportActivation>} The activation data.
 */
export function getAladdinExportActivationById(id) {
  return instance
    .get(`/aladdin-export-activations/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Partially updates an AladdinExportActivation instance by its ID.
 * Corresponds to the updateById method in the controller.
 *
 * @param {string} id The ID of the AladdinExportActivation to update.
 * @param {Partial<AladdinExportActivation>} aladdinExportActivation An object containing the fields to update.
 * @returns {Promise<void>} A promise that resolves when the update is successful.
 */
export function updateAladdinExportActivationById(id, aladdinExportActivation) {
  return instance
    .patch(`/aladdin-export-activations/${id}`, aladdinExportActivation)
    .then((response) => {
      // The PATCH endpoint returns a 204 No Content, so we don't expect a body.
      return response.data;
    });
}

export function getAladdinExportConfigurations(countryId, academicYear) {
  const params = {};
  if (countryId) params.countryId = countryId;
  if (academicYear) params.academicYear = academicYear;
  return instance
    .get('/admin/aladdin-export/configurations', { params })
    .then((response) => response.data);
}

export function updateAladdinExportConfiguration(
  countryId,
  academicYear,
  assessmentId,
  configuration
) {
  return instance
    .put(
      `/admin/aladdin-export/configurations/${countryId}/${encodeURIComponent(academicYear)}/${assessmentId}`,
      configuration
    )
    .then((response) => response.data);
}


/**
 * Create a new GradeLevel3 feature access for a school
 *
 * @param {string} schoolid
 * @param {boolean} active
 * @returns GradeLevel3FeatureAccess record
 */
export function createGradeLevel3FeatureAccess(schoolid, active = true) {
  return instance
    .post("/grade-level-3-feature-accesses", { schoolid, active })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all active school IDs with GradeLevel3 feature access
 *
 * @returns Array of active school IDs
 */
export function getActiveGradeLevel3Schools() {
  return instance
    .get("/grade-level-3-feature-accesses/active-schools")
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate GradeLevel3 feature access for a school
 *
 * @param {string} accessId
 * @returns void
 */
export function deactivateGradeLevel3FeatureAccess(accessId) {
  return instance
    .patch(`/grade-level-3-feature-accesses/${accessId}/deactivate`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all GradeLevel3 feature access records by school ID
 *
 * @param {string} schoolid
 * @returns Array of GradeLevel3FeatureAccess records
 */
export function getGradeLevel3FeatureAccessBySchoolId(schoolid) {
  return instance
    .get(`/grade-level-3-feature-accesses/by-schoolid/${schoolid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a single GradeLevel3 feature access record by ID
 *
 * @param {string} accessId
 * @returns GradeLevel3FeatureAccess record
 */
export function getGradeLevel3FeatureAccessById(accessId) {
  return instance
    .get(`/grade-level-3-feature-accesses/${accessId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all GradeLevel3 feature access records
 *
 * @returns Array of all GradeLevel3FeatureAccess records
 */
export function getAllGradeLevel3FeatureAccess() {
  return instance
    .get("/grade-level-3-feature-accesses")
    .then((response) => {
      return response.data;
    });
}

/**
 * Update a GradeLevel3 feature access record
 *
 * @param {string} accessId
 * @param {object} updates
 * @returns void
 */
export function updateGradeLevel3FeatureAccess(accessId, updates) {
  return instance
    .patch(`/grade-level-3-feature-accesses/${accessId}`, updates)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete a GradeLevel3 feature access record
 *
 * @param {string} accessId
 * @returns void
 */
export function deleteGradeLevel3FeatureAccess(accessId) {
  return instance
    .delete(`/grade-level-3-feature-accesses/${accessId}`)
    .then((response) => {
      return response.data;
    });
}


// ============================================
// TRIAL DEFINITION ENDPOINTS (Admin)
// ============================================

/**
 * Create a new trial definition
 * @param {object} trialDefinition - Trial definition data
 * @returns {Promise} Created trial definition
 */
export function createTrialDefinition(trialDefinition) {
  return instance
    .post("/trial-definitions", trialDefinition)
    .then((response) => response.data);
}

/**
 * Get all trial definitions
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of trial definitions
 */
export function getTrialDefinitions(filter = {}) {
  return instance
    .get("/trial-definitions", { params: filter })
    .then((response) => response.data);
}

/**
 * Get active trial definitions only
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of active trial definitions
 */
export function getActiveTrialDefinitions(filter = {}) {
  return instance
    .get("/trial-definitions/active", { params: filter })
    .then((response) => response.data);
}

/**
 * Get trial definitions by country
 * @param {string} countryId - Country ID
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of trial definitions for country
 */
export function getTrialDefinitionsByCountry(countryId, filter = {}) {
  return instance
    .get(`/trial-definitions/by-country/${countryId}`, { params: filter })
    .then((response) => response.data);
}

/**
 * Get a single trial definition by ID
 * @param {string} id - Trial definition ID
 * @returns {Promise} Trial definition
 */
export function getTrialDefinitionById(id) {
  return instance
    .get(`/trial-definitions/${id}`)
    .then((response) => response.data);
}

/**
 * Update a trial definition
 * @param {string} id - Trial definition ID
 * @param {object} updates - Fields to update
 * @returns {Promise}
 */
export function updateTrialDefinition(id, updates) {
  return instance
    .patch(`/trial-definitions/${id}`, updates)
    .then((response) => response.data);
}

/**
 * Soft delete a trial definition (sets active to false)
 * @param {string} id - Trial definition ID
 * @returns {Promise}
 */
export function deleteTrialDefinition(id) {
  return instance
    .delete(`/trial-definitions/${id}`)
    .then((response) => response.data);
}

// ============================================
// PURCHASE OPTION ENDPOINTS (Admin)
// ============================================

/**
 * Create a new purchase option
 * @param {object} purchaseOption - Purchase option data
 * @returns {Promise} Created purchase option
 */
export function createPurchaseOption(purchaseOption) {
  return instance
    .post("/purchase-options", purchaseOption)
    .then((response) => response.data);
}

/**
 * Get all purchase options
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of purchase options
 */
export function getPurchaseOptions(filter = {}) {
  return instance
    .get("/purchase-options", { params: filter })
    .then((response) => response.data);
}

/**
 * Get active purchase options only
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of active purchase options
 */
export function getActivePurchaseOptions(filter = {}) {
  return instance
    .get("/purchase-options/active", { params: filter })
    .then((response) => response.data);
}

/**
 * Get purchase options by country
 * @param {string} countryId - Country ID
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of purchase options for country
 */
export function getPurchaseOptionsByCountry(countryId, filter = {}) {
  return instance
    .get(`/purchase-options/by-country/${countryId}`, { params: filter })
    .then((response) => response.data);
}

/**
 * Get a single purchase option by ID
 * @param {string} id - Purchase option ID
 * @returns {Promise} Purchase option
 */
export function getPurchaseOptionById(id) {
  return instance
    .get(`/purchase-options/${id}`)
    .then((response) => response.data);
}

/**
 * Update a purchase option
 * @param {string} id - Purchase option ID
 * @param {object} updates - Fields to update
 * @returns {Promise}
 */
export function updatePurchaseOption(id, updates) {
  return instance
    .patch(`/purchase-options/${id}`, updates)
    .then((response) => response.data);
}

/**
 * Soft delete a purchase option (sets active to false)
 * @param {string} id - Purchase option ID
 * @returns {Promise}
 */
export function deletePurchaseOption(id) {
  return instance
    .delete(`/purchase-options/${id}`)
    .then((response) => response.data);
}

// ============================================
// TRIAL INSTANCE ENDPOINTS (Client/Admin)
// ============================================

/**
 * Create a new trial instance
 * @param {object} trialInstance - Trial instance data
 * @returns {Promise} Created trial instance
 */
export function createTrialInstance(trialInstance) {
  return instance
    .post("/trial-instances", trialInstance)
    .then((response) => response.data);
}

/**
 * Create a trial instance using schoolid and trial definition id
 * @param {string} schoolId - School ID
 * @param {string} trialDefinitionId - Trial definition ID
 * @returns {Promise} Created trial instance
 */
export function createTrialInstanceBySchoolAndTrial(schoolId, trialDefinitionId) {
  return instance
    .post(`/trial-instances/${schoolId}/${trialDefinitionId}`)
    .then((response) => response.data);
}

/**
 * Get all trial instances
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of trial instances
 */
export function getTrialInstances(filter = {}) {
  return instance
    .get("/trial-instances", { params: filter })
    .then((response) => response.data);
}

/**
 * Get all trial instances for a specific school
 * @param {string} schoolId - School ID
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of trial instances
 */
export function getTrialInstancesBySchool(schoolId, filter = {}) {
  return instance
    .get(`/trial-instances/school/${schoolId}`, { params: filter })
    .then((response) => response.data);
}

/**
 * Get active trial instances for a specific school
 * @param {string} schoolId - School ID
 * @returns {Promise} Array of active trial instances
 */
export function getActiveTrialInstancesBySchool(schoolId) {
  return instance
    .get(`/trial-instances/active/school/${schoolId}`)
    .then((response) => response.data);
}

/**
 * Get a single trial instance by ID
 * @param {string} id - Trial instance ID
 * @returns {Promise} Trial instance
 */
export function getTrialInstanceById(id) {
  return instance
    .get(`/trial-instances/${id}`)
    .then((response) => response.data);
}

/**
 * Update trial instance by school ID (smart update with date recalculation)
 * @param {string} schoolId - School ID
 * @param {object} updates - Fields to update
 * @returns {Promise} Updated trial instance
 */
export function updateTrialInstanceBySchool(schoolId, updates) {
  return instance
    .patch(`/trial-instances/school/${schoolId}/update`, updates)
    .then((response) => response.data);
}

/**
 * Update trial start date for a school
 * @param {string} schoolId - School ID
 * @param {string} startDate - ISO date string
 * @returns {Promise}
 */
export function updateTrialStartDate(schoolId, startDate) {
  return instance
    .patch(`/trial-instances/school/${schoolId}/start`, { start_date: startDate })
    .then((response) => response.data);
}

/**
 * Update trial end date for a school
 * @param {string} schoolId - School ID
 * @param {string} endDate - ISO date string
 * @returns {Promise}
 */
export function updateTrialEndDate(schoolId, endDate) {
  return instance
    .patch(`/trial-instances/school/${schoolId}/end`, { end_date: endDate })
    .then((response) => response.data);
}

/**
 * Apply 7-day extension to trial
 * @param {string} schoolId - School ID
 * @returns {Promise}
 */
export function applyTrialExtension(schoolId) {
  return instance
    .patch(`/trial-instances/school/${schoolId}/extension`)
    .then((response) => response.data);
}

/**
 * Mark trial as completed for a school
 * @param {string} schoolId - School ID
 * @param {boolean} completed - Completion status
 * @returns {Promise}
 */
export function markTrialCompleted(schoolId, completed) {
  return instance
    .patch(`/trial-instances/school/${schoolId}/completed`, { completed })
    .then((response) => response.data);
}

/**
 * Mark trial as expired for a school
 * @param {string} schoolId - School ID
 * @param {boolean} expired - Expiry status
 * @returns {Promise}
 */
export function markTrialExpired(schoolId, expired) {
  return instance
    .patch(`/trial-instances/school/${schoolId}/expired`, { expired })
    .then((response) => response.data);
}

/**
 * Update trial instance by ID
 * @param {string} id - Trial instance ID
 * @param {object} updates - Fields to update
 * @returns {Promise}
 */
export function updateTrialInstance(id, updates) {
  return instance
    .patch(`/trial-instances/${id}`, updates)
    .then((response) => response.data);
}

/**
 * Mark trial as completed by ID
 * @param {string} id - Trial instance ID
 * @returns {Promise}
 */
export function markTrialCompletedById(id) {
  return instance
    .patch(`/trial-instances/${id}/complete`)
    .then((response) => response.data);
}

/**
 * Mark trial as expired by ID
 * @param {string} id - Trial instance ID
 * @returns {Promise}
 */
export function markTrialExpiredById(id) {
  return instance
    .patch(`/trial-instances/${id}/expire`)
    .then((response) => response.data);
}

/**
 * Mark trial as converted to purchase
 * @param {string} id - Trial instance ID
 * @returns {Promise}
 */
export function markTrialConverted(id) {
  return instance
    .patch(`/trial-instances/${id}/convert`)
    .then((response) => response.data);
}

// ============================================
// PURCHASE INSTANCE ENDPOINTS (Client/Admin)
// ============================================

/**
 * Create a new purchase instance
 * @param {object} purchaseInstance - Purchase instance data
 * @returns {Promise} Created purchase instance
 */
export function createPurchaseInstance(purchaseInstance) {
  return instance
    .post("/purchase-instances", purchaseInstance)
    .then((response) => response.data);
}

/**
 * Get all purchase instances
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of purchase instances
 */
export function getPurchaseInstances(filter = {}) {
  return instance
    .get("/purchase-instances", { params: filter })
    .then((response) => response.data);
}

/**
 * Get all purchase instances for a specific school
 * @param {string} schoolId - School ID
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of purchase instances
 */
export function getPurchaseInstancesBySchool(schoolId, filter = {}) {
  return instance
    .get(`/purchase-instances/school/${schoolId}`, { params: filter })
    .then((response) => response.data);
}

/**
 * Get active purchase instances for a specific school
 * @param {string} schoolId - School ID
 * @returns {Promise} Array of active purchase instances
 */
export function getActivePurchaseInstancesBySchool(schoolId) {
  return instance
    .get(`/purchase-instances/active/school/${schoolId}`)
    .then((response) => response.data);
}

/**
 * Get purchase instances by academic year
 * @param {string} academicYear - Academic year (e.g., "2025-26")
 * @param {object} filter - Optional filter parameters
 * @returns {Promise} Array of purchase instances
 */
export function getPurchaseInstancesByAcademicYear(academicYear, filter = {}) {
  return instance
    .get(`/purchase-instances/by-academic-year/${academicYear}`, { params: filter })
    .then((response) => response.data);
}

/**
 * Get purchase instances for a school and academic year
 * @param {string} schoolId - School ID
 * @param {string} academicYear - Academic year (e.g., "2025-26")
 * @returns {Promise} Array of purchase instances
 */
export function getPurchaseInstancesBySchoolAndYear(schoolId, academicYear) {
  return instance
    .get(`/purchase-instances/school/${schoolId}/academic-year/${academicYear}`)
    .then((response) => response.data);
}

/**
 * Get a single purchase instance by ID
 * @param {string} id - Purchase instance ID
 * @returns {Promise} Purchase instance
 */
export function getPurchaseInstanceById(id) {
  return instance
    .get(`/purchase-instances/${id}`)
    .then((response) => response.data);
}

/**
 * Create purchase by school rollnumber (CRITICAL for admin)
 * @param {string} rollnumber - School rollnumber
 * @param {object} purchaseData - Purchase data including purchaser_name, purchase_option_id, academicyear
 * @returns {Promise} Created purchase instance with message
 */
export function createPurchaseByRollnumber(rollnumber, purchaseData) {
  return instance
    .patch(`/purchase-instances/school/rollnumber/${rollnumber}/purchase`, purchaseData)
    .then((response) => response.data);
}

/**
 * Create purchase instance for a specific school (admin)
 * @param {string} schoolId - School ID
 * @param {object} purchaseData - Purchase data
 * @returns {Promise} Created purchase instance
 */
export function createPurchaseInstanceForSchool(schoolId, purchaseData) {
  return instance
    .post(`/purchase-instances/school/${schoolId}`, purchaseData)
    .then((response) => response.data);
}

/**
 * Update purchase instance by ID
 * @param {string} id - Purchase instance ID
 * @param {object} updates - Fields to update
 * @returns {Promise}
 */
export function updatePurchaseInstance(id, updates) {
  return instance
    .patch(`/purchase-instances/${id}`, updates)
    .then((response) => response.data);
}

/**
 * Update purchase instances by school ID (admin)
 * @param {string} schoolId - School ID
 * @param {object} updates - Fields to update
 * @param {object} where - Additional where clause
 * @returns {Promise} Count of updated records
 */
export function updatePurchaseInstancesBySchool(schoolId, updates, where = {}) {
  return instance
    .patch(`/purchase-instances/school/${schoolId}`, updates, { params: { where } })
    .then((response) => response.data);
}

/**
 * Mark purchase as expired
 * @param {string} id - Purchase instance ID
 * @returns {Promise}
 */
export function markPurchaseExpired(id) {
  return instance
    .patch(`/purchase-instances/${id}/expire`)
    .then((response) => response.data);
}

/**
 * Mark purchase as cancelled
 * @param {string} id - Purchase instance ID
 * @returns {Promise}
 */
export function markPurchaseCancelled(id) {
  return instance
    .patch(`/purchase-instances/${id}/cancel`)
    .then((response) => response.data);
}

/**
 * Mark purchase as active
 * @param {string} id - Purchase instance ID
 * @returns {Promise}
 */
export function markPurchaseActive(id) {
  return instance
    .patch(`/purchase-instances/${id}/activate`)
    .then((response) => response.data);
}

/**
 * Delete purchase instance (admin only)
 * @param {string} id - Purchase instance ID
 * @returns {Promise}
 */
export function deletePurchaseInstance(id) {
  return instance
    .delete(`/purchase-instances/${id}`)
    .then((response) => response.data);
}

/**
 * Send purchase email to teacher
 * @param {object} emailData - Email data including email, teacherName, purchaseFormUrl
 * @returns {Promise} Success message
 */
export function sendPurchaseEmail(emailData) {
  return instance
    .post("/purchase-instances/send-purchase-email", emailData)
    .then((response) => response.data);
}

// ============================================
// SCHOOL ACCESS ENDPOINTS (Client - SUPER GET)
// ============================================

/**
 * Get complete access information for a school (SUPER GET)
 * This returns trial status, purchase status, available grade levels, and expiry info
 * @param {string} schoolId - School ID
 * @param {string} academicYear - Optional academic year filter
 * @returns {Promise} Complete school access information
 */
export function getSchoolAccess(schoolId, academicYear = null) {
  const params = academicYear ? { academicYear } : {};
  return instance
    .get(`/school-access/${schoolId}`, { params })
    .then((response) => response.data);
}

/**
 * Quick check if school has any active access (trial or purchase)
 * @param {string} schoolId - School ID
 * @returns {Promise} Object with hasAccess and accessType
 */
export function quickAccessCheck(schoolId) {
  return instance
    .get(`/school-access/${schoolId}/quick-check`)
    .then((response) => response.data);
}

// ============================================
// HELPER/UTILITY FUNCTIONS
// ============================================

/**
 * Get current academic year string
 * @returns {string} Current academic year in format "YYYY-YY"
 */
export function getCurrentAcademicYear() {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // 0-indexed

  // Assuming academic year starts in September (month 9)
  if (currentMonth >= 9) {
    // September or later - current academic year
    const nextYear = (currentYear + 1).toString().slice(-2);
    return `${currentYear}-${nextYear}`;
  } else {
    // Before September - previous academic year
    const prevYear = currentYear - 1;
    const currentYearShort = currentYear.toString().slice(-2);
    return `${prevYear}-${currentYearShort}`;
  }
}


// ============================================================================
// MOCK API FUNCTIONS FOR ONBOARDING TRACKER
// Paste these into your APIClient.js file
// Replace with real API calls once backend is implemented
// ============================================================================

/**
 * Get onboarding pipeline overview data (MOCK)
 * Returns current snapshot and funnel view data for all stages
 */
export const getOnboardingPipelineOverview = async (
  countryId,
  academicYear,
  onboardingStartDate,
  stageFilter = ''
) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 800));

  // Mock data - this structure should match your real backend response
  const mockData = {
    totalSchools: 160,
    converted: 2,
    conversionRate: 1.3,
    avgDaysToPurchase: 45,
    biggestDropoff: "loo_sent -> loo_signed",

    // Current Snapshot: Where schools are RIGHT NOW (most recent event)
    currentSnapshot: {
      trial_form_submitted: 32,
      loo_sent: 24,
      loo_signed: 19,
      unique_url_sent: 16,
      al_signup_completed: 22,
      trial_started: 13,
      class_created: 11,
      student_added: 10,
      screener_assigned: 8,
      screener_completed: 3,
      purchase_completed: 2
    },

    // Funnel View: How many have REACHED each stage (cumulative)
    funnelView: {
      trial_form_submitted: 160,
      loo_sent: 142,
      loo_signed: 118,
      unique_url_sent: 99,
      al_signup_completed: 83,
      trial_started: 61,
      class_created: 48,
      student_added: 37,
      screener_assigned: 27,
      screener_completed: 19,
      purchase_completed: 2
    }
  };

  return { data: mockData };
};

/**
 * Get schools by onboarding stage (MOCK)
 * Returns list of schools currently at a specific onboarding stage
 */
export const getOnboardingSchoolsByStage = async (
  countryId,
  academicYear,
  onboardingStartDate,
  stageKey
) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 600));

  // Mock data organized by stage
  const mockSchoolsByStage = {
    trial_form_submitted: [
      {
        schoolId: "uuid-1",
        schoolName: "St. Mary's National School",
        rollNumber: "12345",
        contactEmail: "principal@stmarys.ie",
        principalName: "Mary O'Connor",
        lastEventDate: "2025-10-15T10:30:00Z",
        lastEventType: "trial_form_submitted",
        daysAtStage: 14,
        totalEvents: 1,
        hubspotContactId: "12345678",
        estimatedGrade1Students: 25,
        estimatedGrade2Students: 22
      },
      {
        schoolId: "uuid-2",
        schoolName: "Holy Cross Primary School",
        rollNumber: "67890",
        contactEmail: "admin@holycross.ie",
        principalName: "John Murphy",
        lastEventDate: "2025-10-28T14:20:00Z",
        lastEventType: "trial_form_submitted",
        daysAtStage: 2,
        totalEvents: 1,
        estimatedGrade1Students: 30,
        estimatedGrade2Students: 28
      },
      {
        schoolId: "uuid-3",
        schoolName: "Scoil Bhríde",
        rollNumber: "11111",
        contactEmail: "office@scoilbhride.ie",
        principalName: "Áine Ní Mhuirí",
        lastEventDate: "2025-10-20T09:15:00Z",
        lastEventType: "trial_form_submitted",
        daysAtStage: 10,
        totalEvents: 1,
        estimatedGrade1Students: 18,
        estimatedGrade2Students: 20
      }
    ],

    loo_sent: [
      {
        schoolId: "uuid-4",
        schoolName: "Gaelscoil Mhuire",
        rollNumber: "11223",
        contactEmail: "info@gaelscoil.ie",
        principalName: "Siobhán Ní Bhriain",
        lastEventDate: "2025-10-08T11:00:00Z",
        lastEventType: "loo_sent",
        daysAtStage: 22,
        totalEvents: 2,
        hubspotContactId: "98765432"
      },
      {
        schoolId: "uuid-5",
        schoolName: "St. Patrick's Boys School",
        rollNumber: "22334",
        contactEmail: "principal@stpatricks.ie",
        principalName: "Michael O'Sullivan",
        lastEventDate: "2025-10-18T15:45:00Z",
        lastEventType: "loo_sent",
        daysAtStage: 12,
        totalEvents: 2
      },
      {
        schoolId: "uuid-6",
        schoolName: "Presentation Primary School",
        rollNumber: "33445",
        contactEmail: "admin@presentation.ie",
        principalName: "Sarah Walsh",
        lastEventDate: "2025-10-25T10:20:00Z",
        lastEventType: "loo_sent",
        daysAtStage: 5,
        totalEvents: 2
      }
    ],

    loo_signed: [
      {
        schoolId: "uuid-7",
        schoolName: "Scoil Pádraig Naofa",
        rollNumber: "44556",
        contactEmail: "school@scoilpadraig.ie",
        principalName: "Patrick Walsh",
        lastEventDate: "2025-10-28T16:30:00Z",
        lastEventType: "loo_signed",
        daysAtStage: 2,
        totalEvents: 3
      },
      {
        schoolId: "uuid-8",
        schoolName: "Our Lady's National School",
        rollNumber: "55667",
        contactEmail: "principal@ourladys.ie",
        principalName: "Margaret Brennan",
        lastEventDate: "2025-10-22T13:00:00Z",
        lastEventType: "loo_signed",
        daysAtStage: 8,
        totalEvents: 3
      }
    ],

    unique_url_sent: [
      {
        schoolId: "uuid-9",
        schoolName: "St. Joseph's Primary",
        rollNumber: "66778",
        contactEmail: "info@stjosephs.ie",
        principalName: "David Kelly",
        lastEventDate: "2025-10-26T09:30:00Z",
        lastEventType: "unique_url_sent",
        daysAtStage: 4,
        totalEvents: 4
      }
    ],

    al_signup_completed: [
      {
        schoolId: "uuid-10",
        schoolName: "St. Brigid's Girls School",
        rollNumber: "77889",
        contactEmail: "principal@stbrigids.ie",
        principalName: "Catherine Ryan",
        lastEventDate: "2025-10-22T14:15:00Z",
        lastEventType: "al_signup_completed",
        daysAtStage: 8,
        totalEvents: 5,
        teacherId: "teacher-123"
      },
      {
        schoolId: "uuid-11",
        schoolName: "Mercy Primary School",
        rollNumber: "88990",
        contactEmail: "office@mercyprimary.ie",
        principalName: "Anne Marie Collins",
        lastEventDate: "2025-10-27T11:45:00Z",
        lastEventType: "al_signup_completed",
        daysAtStage: 3,
        totalEvents: 5,
        teacherId: "teacher-456"
      }
    ],

    trial_started: [
      {
        schoolId: "uuid-12",
        schoolName: "Holy Family National School",
        rollNumber: "99001",
        contactEmail: "admin@holyfamily.ie",
        principalName: "Thomas Fitzgerald",
        lastEventDate: "2025-10-24T10:00:00Z",
        lastEventType: "trial_started",
        daysAtStage: 6,
        totalEvents: 6,
        trialistId: "trial-789"
      }
    ],

    class_created: [
      {
        schoolId: "uuid-13",
        schoolName: "Sacred Heart Primary",
        rollNumber: "10203",
        contactEmail: "principal@sacredheart.ie",
        principalName: "Fiona Murphy",
        lastEventDate: "2025-10-25T15:20:00Z",
        lastEventType: "class_created",
        daysAtStage: 5,
        totalEvents: 7,
        classId: "class-101",
        className: "Junior Infants A"
      }
    ],

    student_added: [
      {
        schoolId: "uuid-14",
        schoolName: "St. Anne's National School",
        rollNumber: "20304",
        contactEmail: "info@stannes.ie",
        principalName: "Mary Doyle",
        lastEventDate: "2025-10-26T12:30:00Z",
        lastEventType: "student_added",
        daysAtStage: 4,
        totalEvents: 8,
        totalStudents: 5
      }
    ],

    screener_assigned: [
      {
        schoolId: "uuid-15",
        schoolName: "St. John's Primary",
        rollNumber: "30405",
        contactEmail: "principal@stjohns.ie",
        principalName: "James O'Brien",
        lastEventDate: "2025-10-27T10:45:00Z",
        lastEventType: "screener_assigned",
        daysAtStage: 3,
        totalEvents: 9,
        assessmentId: "assessment-202"
      }
    ],

    screener_completed: [
      {
        schoolId: "uuid-16",
        schoolName: "Loreto Primary School",
        rollNumber: "40506",
        contactEmail: "admin@loreto.ie",
        principalName: "Sinead McCarthy",
        lastEventDate: "2025-10-28T14:00:00Z",
        lastEventType: "screener_completed",
        daysAtStage: 2,
        totalEvents: 10,
        totalScreeners: 3
      }
    ],

    purchase_completed: [
      {
        schoolId: "uuid-17",
        schoolName: "Clonmel Community School",
        rollNumber: "99001",
        contactEmail: "principal@clonmel.ie",
        principalName: "Robert Johnson",
        lastEventDate: "2025-10-28T16:30:00Z",
        lastEventType: "purchase_completed",
        daysAtStage: 0,
        totalEvents: 11,
        purchaseId: "purchase-555",
        purchaseAmount: 2450,
        purchaserName: "Robert Johnson"
      },
      {
        schoolId: "uuid-18",
        schoolName: "St. Michael's School",
        rollNumber: "88776",
        contactEmail: "office@stmichaels.ie",
        principalName: "Patricia Kennedy",
        lastEventDate: "2025-10-25T11:00:00Z",
        lastEventType: "purchase_completed",
        daysAtStage: 5,
        totalEvents: 11,
        purchaseId: "purchase-556",
        purchaseAmount: 1890
      }
    ]
  };

  // Return the schools for the requested stage
  const schools = mockSchoolsByStage[stageKey] || [];

  return { data: schools };
};

/**
 * Get onboarding event timeline for a specific school (MOCK - OPTIONAL)
 * Returns chronological list of all onboarding events for a school
 */
export const getSchoolOnboardingTimeline = async (rollNumber) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));

  // Mock timeline data
  const mockTimeline = {
    school: {
      id: "uuid-1",
      name: "St. Mary's National School",
      rollNumber: rollNumber
    },
    timeline: [
      {
        id: "event-uuid-1",
        eventType: "trial_form_submitted",
        timestamp: "2025-10-01T10:00:00Z",
        triggeredBy: "hubspot_workflow",
        payload: {
          principal_email: "principal@stmarys.ie",
          principal_name: "Mary O'Connor",
          estimated_gradelevel1_students: 25,
          estimated_gradelevel2_students: 22
        }
      },
      {
        id: "event-uuid-2",
        eventType: "loo_sent",
        timestamp: "2025-10-03T14:30:00Z",
        triggeredBy: "manual",
        triggeredByName: "Sales Rep Name",
        payload: {
          loo_sent_by: "sales@company.com"
        }
      }
    ],
    currentStage: "loo_sent",
    daysInOnboarding: 29,
    stageTransitions: [
      {
        fromStage: "trial_form_submitted",
        toStage: "loo_sent",
        daysToTransition: 2
      }
    ]
  };

  return { data: mockTimeline };
};

/**
 * Get onboarding bottleneck analysis (MOCK - OPTIONAL)
 * Returns stages with longest average duration and highest drop-off rates
 */
export const getOnboardingBottlenecks = async (
  countryId,
  academicYear,
  onboardingStartDate
) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 700));

  // Mock bottleneck data
  const mockBottlenecks = {
    longestStages: [
      {
        stage: "loo_sent",
        avgDays: 21.5,
        medianDays: 18,
        schoolsStuck: 24
      },
      {
        stage: "al_signup_completed",
        avgDays: 15.2,
        medianDays: 12,
        schoolsStuck: 22
      },
      {
        stage: "trial_started",
        avgDays: 12.8,
        medianDays: 10,
        schoolsStuck: 13
      }
    ],
    highestDropoff: [
      {
        fromStage: "loo_sent",
        toStage: "loo_signed",
        dropoffRate: 37.5,
        schoolsLost: 24
      },
      {
        fromStage: "trial_started",
        toStage: "class_created",
        dropoffRate: 28.3,
        schoolsLost: 13
      }
    ]
  };

  return { data: mockBottlenecks };
};

// ============================================================================
// NOTES:
// ============================================================================
// 1. These functions simulate async API calls with setTimeout
// 2. The response format matches exactly what your backend should return
// 3. Replace these with real API calls once backend is implemented:
//    
//    export const getOnboardingPipelineOverview = async (...params) => {
//        return await api.get('/onboarding/pipeline-overview', { params });
//    };
//
// 4. The mock data structure should be identical to your real backend response
// ============================================================================


/**
 * Get onboarding pipeline overview with funnel metrics
 *
 * @param {string} countryId - Required: UUID of the country
 * @param {object} options - Optional parameters
 * @param {string} options.academicYear - e.g., "25-26"
 * @param {string} options.onboardingStartDate - e.g., "2025-08-01" (YYYY-MM-DD)
 * @param {string} options.stageFilter - e.g., "loo_sent"
 * @returns Promise with pipeline overview data
 */
export function getPipelineOverview(countryId, options = {}) {
  const params = {
    country_id: countryId,
    ...(options.academicYear && { academic_year: options.academicYear }),
    ...options.onboardingStartDate && { onboarding_start_date: options.onboardingStartDate },
    ...options.stageFilter && { stage_filter: options.stageFilter },
  };

  return instance
    .get("/onboarding/pipeline-overview", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get list of schools currently at a specific onboarding stage
 *
 * @param {string} countryId - Required: UUID of the country
 * @param {string} stage - Required: Stage name (e.g., "loo_sent", "trial_started")
 * @param {object} options - Optional parameters
 * @param {string} options.academicYear - e.g., "25-26"
 * @param {string} options.onboardingStartDate - e.g., "2025-08-01" (YYYY-MM-DD)
 * @returns Promise with array of schools at the specified stage
 */
export function getSchoolsByStage(countryId, stage, options = {}) {
  const params = {
    country_id: countryId,
    stage: stage,
    ...options.academicYear && { academic_year: options.academicYear },
    ...options.onboardingStartDate && { onboarding_start_date: options.onboardingStartDate },
  };

  return instance
    .get("/onboarding/schools-by-stage", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Bulk transition all classes of a specific grade level at a school
 *
 * @param {string} schoolId - ID of the school
 * @param {number} currentGradeLevel - Current grade level to transition (1, 2, 3, etc.)
 * @param {string} newAcademicYear - New academic year (e.g., "25-26")
 * @param {string} transitionReason - Reason for transition (optional, defaults to "Automated Grade Promotion")
 * @returns Enhanced bulk transition result with comprehensive reporting
 */
export function bulkTransitionGradeLevel(
  schoolId,
  currentGradeLevel,
  newAcademicYear,
  transitionReason = "Automated Grade Promotion"
) {
  return instance
    .post(`/schools/${schoolId}/transition-grade`, {
      currentGradeLevel: currentGradeLevel,
      newAcademicYear: newAcademicYear,
      transitionReason: transitionReason,
    })
    .then((response) => {
      return response.data;
    });
}

/**
* Switch teacher to a different school (alpaca-staff only)
*
* @param {string} teacherId - The teacher ID to switch
* @param {string} schoolId - The school ID to switch to
* @returns Promise resolving on success or rejecting with error message
*/
export function switchTeacherSchool(teacherId, schoolId) {
  return instance
    .patch(`/teachers/${teacherId}/switch-school/${schoolId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        // Server returned an error response
        const status = error.response.status;
        const message = error.response.data?.message || error.response.data?.error;

        if (status === 404) {
          throw new Error('Teacher or school not found');
        } else if (status === 401) {
          throw new Error('Unauthorized - not authenticated');
        } else if (status === 403) {
          throw new Error('Forbidden - insufficient permissions');
        } else {
          throw new Error(message || 'Failed to switch school');
        }
      } else if (error.request) {
        // Request was made but no response received
        throw new Error('No response from server');
      } else {
        throw new Error('Error: ' + error.message);
      }
    });
}

/**
 * Get all available tag definitions
 *
 * @returns Array of all available features/tags
 */
export function getTagDefinitions() {
  return instance
    .get("/admin/features")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get tags for an entity (school, country, teacher, etc)
 *
 * @param {string} elementType - Type of entity ("school", "country", "teacher")
 * @param {string} elementId - UUID of the entity
 * @returns Array of tags with current values for the entity
 */
export function getEntityTags(elementType, elementId) {
  return instance
    .get(`/admin/${elementType}/${elementId}/access`)
    .then((response) => {
      return response.data;
    });
}

export function getResolvedTags(elementType, tagName, elementIds) {
  return instance
    .get("/admin/tags/resolved", {
      params: {
        elementType,
        tagName,
        elementIds: elementIds.join(","),
      },
    })
    .then((response) => response.data);
}

/**
 * Update tag value for an entity
 *
 * @param {string} elementType - Type of entity ("school", "country", "teacher")
 * @param {string} elementId - UUID of the entity
 * @param {string} tagDefinitionId - UUID of the tag definition
 * @param {string} tagValue - New value for the tag
 * @returns Updated tag object
 */
export function updateEntityTag(elementType, elementId, tagDefinitionId, tagValue, updatedBy) {
  return instance
    .patch(`/admin/${elementType}/${elementId}/features/${tagDefinitionId}`, {
      tag_value: tagValue,
      updated_by: updatedBy,
    })
    .then((response) => {
      return response.data;
    });
}
/**
 * Check if entity has access to a feature
 *
 * @param {string} elementType - Type of entity ("school", "country", "teacher")
 * @param {string} elementId - UUID of the entity
 * @param {string} tagName - Name of the tag/feature
 * @returns Boolean indicating access
 */
export function hasEntityAccess(elementType, elementId, tagName) {
  return getEntityTags(elementType, elementId)
    .then((tags) => {
      const tag = tags.find(t => t.tag_definition?.tag_name === tagName);
      return tag?.tag_value === 'ON';
    });
}


/**
 * Create new tag definition
 *
 * @param {object} tagData - Tag definition data
 * @param {string} tagData.tag_name - Name of the tag
 * @param {string} tagData.description - Description of the tag
 * @param {string} tagData.data_type - Data type (boolean, number, string)
 * @param {string} tagData.default_value - Default value
 * @returns Created tag definition object
 */
export function createTagDefinition(tagData) {
  return instance
    .post("/admin/tag-definitions", tagData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update existing tag definition
 *
 * @param {string} tagDefinitionId - UUID of the tag definition
 * @param {object} tagData - Updated tag definition data
 * @returns Updated tag definition object
 */
export function updateTagDefinition(tagDefinitionId, tagData) {
  return instance
    .patch(`/admin/tag-definitions/${tagDefinitionId}`, tagData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete tag definition
 *
 * @param {string} tagDefinitionId - UUID of the tag definition
 * @returns Confirmation of deletion
 */
export function deleteTagDefinition(tagDefinitionId) {
  return instance
    .delete(`/admin/tag-definitions/${tagDefinitionId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Check if standardised scores are enabled for an assessment
 *
 * @param {string} assessmentId - UUID of the assessment
 * @returns {Promise<boolean>} Boolean indicating if standardised scores are enabled
 */
export function checkStandardisedScoresEnabled(assessmentId) {
  return instance
    .get(`/assessments/${assessmentId}/standardised-scores-enabled`)
    .then((response) => {
      return response.data.enabled;
    })
    .catch((error) => {
      console.error('Error checking standardised scores status:', error);
      return false; // Fail closed - default to disabled
    });
}

/**
 * Get standardised scores tag details for an assessment
 *
 * @param {string} assessmentId - UUID of the assessment
 * @returns {Promise<{enabled: boolean, tagValue: string|null}>} Tag details
 */
export function getStandardisedScoresTag(assessmentId) {
  return instance
    .get(`/assessments/${assessmentId}/standardised-scores-tag`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error getting standardised scores tag:', error);
      return { enabled: false, tagValue: null };
    });
}

/**
 * Get next-year class creation configuration for a country
 * 
 * @param {string} countryId - Country UUID
 * @returns {Promise} Object with enabled (boolean) and availableYears (array)
 */
export function getNextYearClassConfig(countryId) {
  return instance
    .get(`/countries/${countryId}/next-year-class-config`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update next-year class creation configuration for a country
 * 
 * @param {string} countryId - Country UUID
 * @param {boolean} enabled - Whether feature is enabled
 * @param {string[]} availableYears - Array of academic years (e.g., ["25-26", "26-27"])
 * @returns {Promise} Updated config object
 */
export function updateNextYearClassConfig(countryId, enabled, availableYears) {
  return instance
    .patch(`/countries/${countryId}/next-year-class-config`, {
      enabled,
      availableYears,
    })
    .then((response) => {
      return response.data;
    });
}


// ==================== RECOMMENDATIONS ====================

/**
 * Get all recommendations with optional filters
 * @param {Object} filter - LoopBack filter object
 * @returns {Promise} Array of recommendations
 */
export function getAllRecommendations(filter = {}) {
  return instance
    .get("/recommendations", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendation by ID
 * @param {string} id - Recommendation ID
 * @returns {Promise} Recommendation object
 */
export function getRecommendationById(id) {
  return instance
    .get(`/recommendations/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendations by task ID (individual task)
 * @param {string} taskid - Task ID
 * @returns {Promise} Array of recommendations
 */
export function getRecommendationsByTaskId(taskid) {
  return instance
    .get(`/recommendations/task/${taskid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendations by parent task ID (grouped tasks)
 * @param {string} parentTaskId - Parent Task ID
 * @returns {Promise} Array of recommendations
 */
export function getRecommendationsByParentTaskId(parentTaskId) {
  return instance
    .get(`/recommendations/parent/${parentTaskId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendations by assessment ID
 * @param {string} assessmentid - Assessment ID
 * @returns {Promise} Array of grouped recommendations by task
 */
export function getRecommendationsByAssessmentId(assessmentid) {
  return instance
    .get(`/recommendations/assessment/${assessmentid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new recommendation (admin only)
 * @param {Object} recommendation - Recommendation data
 * @returns {Promise} Created recommendation
 */
export function createRecommendation(recommendation) {
  return instance
    .post("/recommendations", recommendation)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update a recommendation by ID (admin only)
 * @param {string} id - Recommendation ID
 * @param {Object} recommendation - Updated recommendation data
 * @returns {Promise}
 */
export function updateRecommendation(id, recommendation) {
  return instance
    .patch(`/recommendations/${id}`, recommendation)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update all recommendations for a parent task (admin only)
 * @param {string} parentTaskId - Parent Task ID
 * @param {Object} data - Updated recommendation data
 * @returns {Promise}
 */
export function updateRecommendationsByParentTaskId(parentTaskId, data) {
  return instance
    .patch(`/recommendations/parent/${parentTaskId}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate a recommendation (admin only)
 * @param {string} id - Recommendation ID
 * @param {string} userName - User making the change
 * @returns {Promise}
 */
export function activateRecommendation(id, userName) {
  return instance
    .patch(`/recommendations/${id}/activate`, null, {
      params: { updated_by: userName }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate a recommendation (admin only)
 * @param {string} id - Recommendation ID
 * @param {string} userName - User making the change
 * @returns {Promise}
 */
export function deactivateRecommendation(id, userName) {
  return instance
    .patch(`/recommendations/${id}/deactivate`, null, {
      params: { updated_by: userName }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get child tasks for a parent task (admin only)
 * @param {string} parentTaskId - Parent Task ID
 * @returns {Promise} Array of child tasks
 */
export function getChildTasksByParentId(parentTaskId) {
  return instance
    .get(`/recommendations/parent/${parentTaskId}/children`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all active assessments
 * @returns {Promise} Array of active assessments
 */
export function getAllAssessments() {
  return instance
    .get("/assessments")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all tasks
 * @param {Object} filter - Optional filter parameters
 * @returns {Promise} Array of tasks
 */
export function getAllTasks(filter) {
  return instance
    .get("/tasks", { params: filter })
    .then((response) => {
      return response.data;
    });
}

// ==========================================
// BANNER CONTENT ENDPOINTS
// ==========================================

/**
 * Get banner content for a specific scenario type
 * Returns both definition and content
 * V1: Only fetches global defaults (no school/country specificity)
 * @param {string} scenarioType - e.g., 'trial_active', 'trial_expired', 'license_active', 'license_expired'
 * @param {string} [countryid] - Optional country ID for country-specific content
 * @returns {Promise} { definition: {...}, content: {...} }
 */
export const getBannerContentByScenario = (scenarioType, countryid) => {
  const params = { locale: 'en-IE' };
  if (countryid) params.countryid = countryid;
  return instance.get(`/banner-contents/by-scenario/${scenarioType}`, { params });
};

/**
 * Update banner content
 * @param {string} id - Content ID
 * @param {object} content - Updated content object
 * @returns {Promise}
 */
export const updateBannerContent = (id, content) => {
  return instance.patch(`/banner-contents/${id}`, content);
};

/**
 * Get all scenario definitions (for admin UI)
 * @returns {Promise} Array of scenario definitions
 */
export const getBannerScenarioDefinitions = () => {
  return instance.get('/banner-scenario-definitions', {
    params: {
      filter: JSON.stringify({ where: { is_active: true } })
    }
  });
};

/**
 * Create a new scenario definition (for admin UI)
 * @param {object} definition - Scenario definition object
 * @returns {Promise} Created scenario definition
 */
export const createBannerScenarioDefinition = (definition) => {
  return instance.post('/banner-scenario-definitions', definition);
};

/**
 * Update a scenario definition
 * @param {string} id - Definition ID
 * @param {object} data - Fields to update
 * @returns {Promise}
 */
export const updateBannerScenarioDefinition = (id, data) => {
  return instance.patch(`/banner-scenario-definitions/${id}`, data);
};

/**
 * Get all banner content records for a specific template
 * @param {string} scenarioDefinitionId - The template/scenario definition ID
 * @returns {Promise} Array of banner content records
 */
export const getBannersByTemplate = (scenarioDefinitionId) => {
  return instance.get('/banner-contents', {
    params: {
      filter: JSON.stringify({ where: { scenario_definition_id: scenarioDefinitionId } })
    }
  });
};

/**
 * Check feature access for any entity type
 *
 * @param {string} elementType - e.g. 'teacher', 'school'
 * @param {string} elementId
 * @param {string} tagName - e.g. 'reports_enabled'
 * @returns {{ enabled: boolean }}
 */
export function checkFeatureAccess(elementType, elementId, tagName) {
  return instance
    .get(`/${elementType}/${elementId}/features/${tagName}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Check feature access for a teacher
 *
 * @param {string} teacherId
 * @param {string} tagName - e.g. 'reports_enabled'
 * @returns {{ enabled: boolean }}
 */
export function checkTeacherFeatureAccess(teacherId, tagName) {
  return instance
    .get(`/teachers/${teacherId}/features/${tagName}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all banner content records (for admin UI)
 * @returns {Promise} Array of content records
 */
export const getAllBannerContent = () => {
  return instance.get('/banner-contents');
};

/**
 * Create a new message
 *
 * @param {object} message - Message object (without id)
 * @returns Created message
 */
export function createMessage(message) {
  return instance
    .post("/messages", message)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all messages
 *
 * @returns Array of messages
 */
export function getMessages() {
  return instance
    .get("/messages")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a message by internal ID
 *
 * @param {string} id
 * @returns Message
 */
export function getMessageById(id) {
  return instance
    .get(`/messages/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update a message by internal ID
 *
 * @param {string} id
 * @param {object} message - Partial message object
 * @returns void
 */
export function updateMessageById(id, message) {
  return instance
    .patch(`/messages/${id}`, message)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete a message by internal ID
 *
 * @param {string} id
 * @returns void
 */
export function deleteMessageById(id) {
  return instance
    .delete(`/messages/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific active message by country and message_id slug
 * Falls back to a global message (no country) if no country-specific one is found
 *
 * @param {string} countryid
 * @param {string} message_id
 * @returns Message or null
 */
export function getMessageByMessageId(countryid, message_id) {
  return instance
    .get(`/messages/client/${countryid}/${message_id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Preview how many students would be assigned without writing anything
 */
export function previewBulkAssignScreener(countryid, assessmentid) {
  return instance
    .post(`/countryscreeners/${countryid}/${assessmentid}/bulk-assign?dryRun=true`)
    .then((response) => response.data);
}

/**
 * Bulk assign screener assessment instances to all eligible students in a country
 */
export function bulkAssignScreener(countryid, assessmentid) {
  return instance
    .post(`/countryscreeners/${countryid}/${assessmentid}/bulk-assign`)
    .then((response) => response.data);
}

// ─── Country Academic Year Config ────────────────────────────────────────────

/**
 * List all country academic year configurations
 */
export function getAcademicYearConfigs() {
  return instance
    .get('/country-academic-year-configs')
    .then((response) => response.data);
}

/**
 * Get academic year configuration for a specific country
 * Returns 404 if no config exists (country uses August default)
 */
export function getAcademicYearConfig(countryid) {
  return instance
    .get(`/country-academic-year-configs/${countryid}`)
    .then((response) => response.data);
}

/**
 * Create academic year config for a country
 * @param {string} countryid
 * @param {number} startMonth - 1-indexed (1=Jan, 12=Dec)
 */
export function createAcademicYearConfig(countryid, startMonth) {
  return instance
    .post('/country-academic-year-configs', { countryid, startMonth })
    .then((response) => response.data);
}

/**
 * Update the academic year start month for a country
 * @param {string} countryid
 * @param {number} startMonth - 1-indexed (1=Jan, 12=Dec)
 */
export function updateAcademicYearConfig(countryid, startMonth) {
  return instance
    .patch(`/country-academic-year-configs/${countryid}`, { startMonth })
    .then((response) => response.data);
}

/**
 * Delete academic year config for a country
 * Country will fall back to August (month 8) as the default
 */
export function deleteAcademicYearConfig(countryid) {
  return instance
    .delete(`/country-academic-year-configs/${countryid}`)
    .then((response) => response.data);
}

/**
 * Create a new school group
 *
 * @param {object} schoolGroup - { name, created_by }
 * @returns Created school group
 */
export function createSchoolGroup(schoolGroup) {
  return instance
    .post("/school-groups", schoolGroup)
    .then((response) => response.data);
}

/**
 * Get all school groups
 *
 * @returns Array of school groups
 */
export function getSchoolGroups() {
  return instance
    .get("/school-groups")
    .then((response) => response.data);
}

/**
 * Get a school group by ID, including its member schools
 *
 * @param {string} id - School group ID
 * @returns School group with member schools
 */
export function getSchoolGroupById(id) {
  return instance
    .get(`/school-groups/${id}`)
    .then((response) => response.data);
}

/**
 * Get the school group that a given school belongs to
 *
 * @param {string} schoolid - School ID
 * @returns School group with member schools, or message if not assigned
 */
export function getSchoolGroupBySchool(schoolid) {
  return instance
    .get(`/school-groups/by-school/${schoolid}`)
    .then((response) => response.data);
}

/**
 * Update a school group
 *
 * @param {string} id - School group ID
 * @param {object} updates - Fields to update e.g. { name }
 */
export function updateSchoolGroup(id, updates) {
  return instance
    .patch(`/school-groups/${id}`, updates)
    .then((response) => response.data);
}

/**
 * Assign a school to a school group
 *
 * @param {string} schoolgroupid - School group ID
 * @param {string} schoolid - School ID to assign
 * @returns Created or existing junction record
 */
export function addSchoolToGroup(schoolgroupid, schoolid) {
  return instance
    .post(`/school-groups/${schoolgroupid}/schools`, { schoolid })
    .then((response) => response.data);
}

/**
 * Remove a school from a school group
 *
 * @param {string} schoolgroupid - School group ID
 * @param {string} schoolid - School ID to remove
 */
export function removeSchoolFromGroup(schoolgroupid, schoolid) {
  return instance
    .delete(`/school-groups/${schoolgroupid}/schools/${schoolid}`)
    .then((response) => response.data);
}

/**
 * Delete a school group and all its school associations
 *
 * @param {string} id - School group ID
 */
export function deleteSchoolGroup(id) {
  return instance
    .delete(`/school-groups/${id}`)
    .then((response) => response.data);
}

export function getAllTaskRecommendations(...taskids) {
  let response = [];
  // taskids.forEach( id => {
  //   response.push( getRecommendations( id ) );
  // })
  const canned = [
    {
      id: 1,
      name: "Rhyming",
      // description: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.',
      // video: 'https://file-examples.com/storage/fe4658769b6331540b05587/2017/04/file_example_MP4_480_1_5MG.mp4',
      files: {
        all: "./docs/Alpaca_Rhyming_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 2,
      name: "Initial Phoneme",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Initial_Phoneme_Isolation_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 3,
      name: "Phoneme Blending",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Phoneme_Blending_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 4,
      name: "Letter-Name Knowledge",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Letter_Name_Knowledge_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 5,
      name: "Phoneme Deletion",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Phoneme_Deletion_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 6,
      name: "Letter-Sound Knowledge",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Letter_Sound_Knowledge_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 7,
      name: "Word Recognition",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Word_Recognition_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
  ];

  response = canned;

  return response;
}

export function getRecommendations(taskid) {
  return instance.get(`/tasks/${taskid}/recommendations`);
}

// /**
//  *
//  * @param {*} classid
//  * @returns
//  */
//  export function getAssessmentStep(classid) {
//   return instance.get(`classes/${classid}/qr`)
//     .then(response => {
//       return response.data;
//     })
// }
